import type { Icon } from '@chakra-ui/icons'
import { createIcon } from '@chakra-ui/icons'

export const Cancel: typeof Icon = createIcon({
  displayName: 'Cancel',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m0-85.333334a341.333333 341.333333 0 1 0 0-682.709333A341.333333 341.333333 0 0 0 512 853.333333z'
        fill='currentColor'
      />
      <path
        d='M361.130667 662.826667c16.682667 16.64 48.213333 12.16 70.4-10.069334l221.269333-221.226666c22.186667-22.186667 26.709333-53.76 10.069333-70.4-16.682667-16.64-48.213333-12.16-70.4 10.069333L371.2 592.426667c-22.186667 22.229333-26.709333 53.76-10.069333 70.4z'
        fill='currentColor'
      />
      <path
        d='M361.130667 361.173333c-16.64 16.64-12.16 48.213333 10.069333 70.4l221.269333 221.226667c22.186667 22.229333 53.717333 26.752 70.4 10.069333 16.64-16.64 12.117333-48.213333-10.069333-70.4l-221.269333-221.226666c-22.186667-22.229333-53.717333-26.752-70.4-10.069334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Search: typeof Icon = createIcon({
  displayName: 'Search',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M920.618667 833.024l-134.101334-134.101333c48.768-65.024 73.130667-146.304 73.130667-227.541334C859.648 260.053333 684.928 85.333333 473.642667 85.333333c-211.328 0-386.048 178.773333-386.048 390.101334 0 211.285333 174.72 386.005333 386.048 386.005333 81.237333 0 162.56-24.362667 227.541333-73.130667l134.101333 134.101334c12.202667 12.202667 28.458667 16.256 44.672 16.256 16.298667 0 32.512-4.053333 44.714667-16.256 16.256-24.362667 16.256-65.024-4.053333-89.386667zM473.6 211.285333a263.594667 263.594667 0 0 1 264.106667 264.106667c0 69.12-24.362667 134.144-73.130667 182.912l-4.053333 4.053333c-48.768 48.768-113.792 73.130667-182.869334 73.130667a263.594667 263.594667 0 0 1-264.106666-264.106667c0-146.304 113.749333-260.096 260.053333-260.096z'
        fill='currentColor'
      />
    </>
  ),
})

export const Money2: typeof Icon = createIcon({
  displayName: 'Money2',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 992c265.088 0 480-214.912 480-480 0-265.088-214.912-480-480-480C246.912 32 32 246.912 32 512c0 265.088 214.912 480 480 480z'
        fill='currentColor'
      />
      <path
        d='M512 919.36c224.96 0 407.36-182.4 407.36-407.36S736.96 104.64 512 104.64 104.64 287.04 104.64 512 287.04 919.36 512 919.36z'
        fill='currentColor'
      />
      <path
        d='M725.184 164.288a405.504 405.504 0 0 1 64.064 219.424c0 224.96-182.4 407.36-407.36 407.36a405.408 405.408 0 0 1-213.184-60.16A406.976 406.976 0 0 0 512 918.88c224.992 0 407.36-182.4 407.36-407.36a407.072 407.072 0 0 0-194.176-347.232z'
        fill='currentColor'
      />
      <path
        d='M176 549.28c0-198.592 160.96-359.616 359.584-359.616a358.976 358.976 0 0 1 285.056 140.416A359.488 359.488 0 0 0 508.8 149.696c-198.592 0-359.648 160.96-359.648 359.584a358.08 358.08 0 0 0 74.56 219.2 358.016 358.016 0 0 1-47.744-179.2z'
        fill='currentColor'
      />
      <path
        d='M504.8 731.2c-42.528 0-79.712-7.776-111.616-23.36-31.872-15.968-56.672-37.92-74.4-65.888-17.312-28.32-25.984-61.088-25.984-98.24 0-36.704 6.304-70.432 18.88-101.184 12.992-30.752 31.328-57.28 54.944-79.68a243.84 243.84 0 0 1 83.84-51.52c32.672-12.352 68.704-18.56 108.064-18.56 43.328 0 80.544 7.008 111.616 20.992a177.792 177.792 0 0 1 76.192 61.088l-99.808 78.464c-13.376-17.6-27.52-29.568-42.528-35.936-14.944-6.784-32.256-10.176-51.936-10.176-18.112 0-34.464 3.2-49.024 9.568a104.8 104.8 0 0 0-37.792 26.368A115.84 115.84 0 0 0 441.6 483.2a153.44 153.44 0 0 0-8.256 51.52c0 16.384 3.52 30.752 10.624 43.136 7.488 12.384 17.92 21.952 31.296 28.736 13.792 6.784 30.144 10.176 49.024 10.176 15.744 0 31.488-2.56 47.232-7.776 15.776-5.6 31.904-14.976 48.448-28.16l52.544 100.64c-21.632 15.968-46.848 28.352-75.584 37.12-28.736 8.384-59.456 12.576-92.128 12.576z m50.784-71.264l31.296-159.328h121.088l-35.456 180.896-116.928-21.568z'
        fill='currentColor'
      />
    </>
  ),
})

export const Down: typeof Icon = createIcon({
  displayName: 'Down',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M384 448V128h256v320h192L512 768l-320-320H384z m-192 384h640V896h-640v-64z'
        fill='currentColor'
      />
    </>
  ),
})

export const User1: typeof Icon = createIcon({
  displayName: 'User1',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M315.306667 705.664a341.333333 341.333333 0 1 1 393.429333 0l88.874667 203.093333a21.333333 21.333333 0 0 1-19.584 29.866667H245.973333a21.333333 21.333333 0 0 1-19.584-29.866667l88.874667-203.093333h0.042667z m287.36-29.568l56.832-40.149333a256 256 0 1 0-294.954667 0l56.789333 40.106666L343.808 853.333333h336.384l-77.525333-177.237333zM346.410667 468.053333l82.773333-20.693333a85.333333 85.333333 0 0 0 165.632 0l82.773333 20.693333a170.752 170.752 0 0 1-331.178666 0z'
        fill='currentColor'
      />
    </>
  ),
})

export const Time: typeof Icon = createIcon({
  displayName: 'Time',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 85.312A426.624 426.624 0 1 1 85.312 512h85.376a341.376 341.376 0 1 0 59.072-192h111.552v85.312h-256v-256h85.376V256A425.856 425.856 0 0 1 512 85.312z m42.688 213.312v195.648l138.368 138.368-60.416 60.352-163.328-163.392V298.624h85.376z'
        fill='currentColor'
      />
    </>
  ),
})

export const Icon_searchData: typeof Icon = createIcon({
  displayName: 'Icon_searchData',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M872.96 894.08l-74.88-74.88a211.2 211.2 0 1 0-177.92 97.28 199.04 199.04 0 0 0 112-32.64l75.52 74.88a44.16 44.16 0 0 0 50.368 10.24 46.08 46.08 0 0 0 14.912-10.24 45.44 45.44 0 0 0 0-64v-0.64z m-133.76-188.8a119.04 119.04 0 1 1-119.04-119.04 119.68 119.68 0 0 1 119.04 119.04zM338.56 481.28H261.12a46.08 46.08 0 0 0 0 92.16h77.44a46.08 46.08 0 0 0 0-92.16zM272.64 626.56h-11.52a46.08 46.08 0 0 0 0 92.16h11.52a46.08 46.08 0 1 0 0-92.16z'
        fill='currentColor'
      />
      <path
        d='M926.08 64H337.92a64 64 0 0 0-64 64v42.24H129.92a64 64 0 0 0-64 64v691.2a64 64 0 0 0 64 64h304a46.08 46.08 0 0 0 0-92.16H160a3.84 3.84 0 0 1-3.84-3.84v-627.2a3.84 3.84 0 0 1 3.84-3.84h528.64a3.84 3.84 0 0 1 3.84 3.84v135.68a46.72 46.72 0 0 0 53.76 37.76 45.44 45.44 0 0 0 37.12-51.2V238.08a64 64 0 0 0-64-64H363.52v-12.16s0-3.84 4.48-3.84h525.44a3.84 3.84 0 0 1 3.84 3.84v597.12a3.84 3.84 0 0 1-3.84 3.84h-23.68a46.08 46.08 0 0 0-46.08 46.08 45.312 45.312 0 0 0 45.44 46.08h54.4a64 64 0 0 0 64-64V129.92A64 64 0 0 0 926.08 64z'
        fill='currentColor'
      />
      <path
        d='M589.44 336H261.12a46.08 46.08 0 0 0-42.432 63.872 44.16 44.16 0 0 0 10.432 14.848 45.44 45.44 0 0 0 32 13.44h328.32a46.08 46.08 0 0 0 0-92.16z'
        fill='currentColor'
      />
    </>
  ),
})

export const Retract1: typeof Icon = createIcon({
  displayName: 'Retract1',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M727.04 512c0 30.72-25.6 51.2-51.2 51.2H563.2v107.52c0 30.72-25.6 51.2-51.2 51.2s-51.2-25.6-51.2-51.2V563.2H353.28c-30.72 0-51.2-25.6-51.2-51.2 0-30.72 25.6-51.2 51.2-51.2H460.8V353.28c0-30.72 25.6-51.2 51.2-51.2s51.2 25.6 51.2 51.2V460.8h107.52c30.72 0 56.32 25.6 56.32 51.2z m204.8-5.12c0 235.52-189.44 419.84-419.84 419.84-235.52 0-419.84-189.44-419.84-419.84S281.6 87.04 512 87.04c230.4 0 419.84 189.44 419.84 419.84z m-66.56 0c0-199.68-158.72-358.4-358.4-358.4s-358.4 158.72-358.4 358.4 158.72 358.4 358.4 358.4 358.4-158.72 358.4-358.4z'
        fill='currentColor'
      />
    </>
  ),
})

export const ArrowGoBackFill: typeof Icon = createIcon({
  displayName: 'ArrowGoBackFill',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M341.333333 298.666667v170.666666L85.333333 256l256-213.333333v170.666666h213.333334a341.333333 341.333333 0 0 1 0 682.666667H170.666667v-85.333333h384a256 256 0 1 0 0-512H341.333333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Switchr: typeof Icon = createIcon({
  displayName: 'Switchr',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M355.498667 151.637333C312.96 123.306667 256 153.770667 256 204.885333v614.186667c0 51.114667 56.96 81.578667 99.498667 53.248l460.629333-307.072a64 64 0 0 0 0-106.496L355.498667 151.594667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Switchl: typeof Icon = createIcon({
  displayName: 'Switchl',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M659.797333 151.637333c42.538667-28.330667 99.498667 2.133333 99.498667 53.248v614.186667c0 51.114667-56.96 81.578667-99.498667 53.248L199.168 565.248a64 64 0 0 1 0-106.496l460.629333-307.114667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Treasure: typeof Icon = createIcon({
  displayName: 'Treasure',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M170.965333 896a42.666667 42.666667 0 0 1-42.666666-42.666667v-332.117333c10.538667 0 20.608 0.256 30.677333-0.213333 2.474667-0.128 6.229333-2.133333 7.04-4.266667 14.464-36.181333 40.362667-59.477333 77.738667-69.973333 1.877333-0.682667 3.712-1.493333 5.461333-2.389334-1.706667-2.645333-3.114667-5.034667-4.821333-7.253333L131.968 283.648A22.357333 22.357333 0 0 1 128 271.189333c0-79.189333 61.696-142.506667 140.8-142.762666 162.176-0.64 324.352-0.64 486.485333 0 78.677333 0.298667 140.842667 64.554667 140.544 143.274666a21.290667 21.290667 0 0 1-4.010666 11.52 41931.946667 41931.946667 0 0 1-112.213334 154.752c-1.578667 2.133333-3.029333 4.309333-4.992 7.210667l7.125334 2.090667c35.242667 10.709333 60.544 32.768 74.538666 67.029333 2.218667 5.461333 4.821333 7.253333 10.410667 7.04 9.514667-0.426667 19.072-0.128 29.013333-0.128V853.333333a42.666667 42.666667 0 0 1-42.666666 42.666667H170.922667z m638.72-375.168c-14.421333-20.736-32.256-31.616-55.722666-32.298667-21.333333-0.64-37.674667-9.514667-49.365334-27.52-18.048-27.818667-46.08-38.229333-78.336-29.653333-24.32 6.442667-44.288-0.213333-59.52-19.84-26.325333-33.92-69.717333-37.930667-101.717333-9.386667-20.309333 18.133333-43.605333 20.437333-66.944 6.741334-39.765333-23.466667-82.730667-8.746667-97.706667 34.858666-8.789333 25.472-24.362667 41.386667-50.389333 48.384-15.274667 4.096-26.88 14.165333-35.712 28.672h595.413333z m37.76-272.853333c-5.930667-34.858667-39.338667-66.816-76.117333-73.002667a125.141333 125.141333 0 0 0-20.693333-1.706667C591.488 173.226667 432.256 173.226667 273.066667 173.226667c-29.013333 0-53.674667 9.813333-73.685334 30.762666-11.861333 12.202667-20.053333 27.434667-23.68 44.032h671.786667z m-298.581333 356.053333a37.034667 37.034667 0 1 0-74.069333 0v14.805333a37.034667 37.034667 0 0 0 74.069333 0v-14.805333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Top: typeof Icon = createIcon({
  displayName: 'Top',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M128 170.666667a42.666667 42.666667 0 0 0 42.666667 42.666666h682.666666a42.666667 42.666667 0 1 0 0-85.333333H170.666667a42.666667 42.666667 0 0 0-42.666667 42.666667z m469.333333 490.666666a21.333333 21.333333 0 0 1 21.333334-21.333333h183.168a21.333333 21.333333 0 0 0 15.061333-36.437333l-289.792-289.792a21.333333 21.333333 0 0 0-30.208 0l-289.792 289.792a21.333333 21.333333 0 0 0 15.061333 36.437333H405.333333a21.333333 21.333333 0 0 1 21.333334 21.333333v298.666667a21.333333 21.333333 0 0 0 21.333333 21.333333h128a21.333333 21.333333 0 0 0 21.333333-21.333333v-298.666667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Retract: typeof Icon = createIcon({
  displayName: 'Retract',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path d='M512 469.333333l256 256H256l256-256z' fill='currentColor' />
    </>
  ),
})

export const Expand: typeof Icon = createIcon({
  displayName: 'Expand',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path d='M512 682.666667l256-256H256l256 256z' fill='currentColor' />
    </>
  ),
})

export const Agent: typeof Icon = createIcon({
  displayName: 'Agent',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M419.925333 554.453333c115.029333 0 208.256-95.445333 208.256-213.205333S534.954667 128 419.925333 128 211.626667 223.445333 211.626667 341.248c0 117.76 93.269333 213.205333 208.298666 213.205333zM500.906667 597.333333H324.096v0.213334A7.594667 7.594667 0 0 0 322.304 597.333333H276.053333C194.304 597.333333 85.333333 681.258667 85.333333 784.896v83.2c0 15.445333 9.898667 27.904 22.016 27.904h461.653334c-55.381333-42.453333-91.605333-112.64-91.605334-192 0-38.4 8.533333-74.666667 23.552-106.666667zM746.666667 896a192 192 0 1 0 0-384 192 192 0 0 0 0 384z m0-85.333333a106.666667 106.666667 0 1 1 0-213.333334 106.666667 106.666667 0 0 1 0 213.333334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Ticket: typeof Icon = createIcon({
  displayName: 'Ticket',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M95.146667 227.072C88.576 236.245333 85.333333 251.477333 85.333333 273.066667c0 0 0 126.805333 0.128 126.848 0 8.704 1.834667 15.018667 5.418667 18.517333 3.712 3.541333 9.557333 6.101333 17.493333 7.722667 10.154667 1.621333 19.84 7.509333 28.885334 17.92 9.002667 10.410667 13.525333 24.746667 13.525333 43.008 0 11.946667-1.834667 22.144-5.418667 30.549333a69.12 69.12 0 0 1-13.098666 20.309333c-5.12 5.205333-10.112 8.96-15.189334 11.306667a31.744 31.744 0 0 1-11.946666 3.541333c-8.106667 1.664-13.226667 4.565333-15.786667 8.96s-3.84 10.88-3.84 19.626667v172.373333c0 22.314667 4.010667 37.461333 11.946667 45.354667 7.893333 7.893333 21.76 11.562667 41.301333 10.666667 5.802667 0 16.512 0.213333 32.128 0.597333 15.573333 0.426667 31.402667 0.597333 47.36 0.597333h59.904V213.333333H138.752c-22.613333 0-36.992 4.522667-43.605333 13.738667z'
        fill='currentColor'
      />
      <path
        d='M894.634667 414.677333a39.04 39.04 0 0 1 22.016-13.738666 29.354667 29.354667 0 0 0 17.194666-12.202667 33.194667 33.194667 0 0 0 4.778667-19.2 38.016 38.016 0 0 0-7.125333-19.626667 39.68 39.68 0 0 0-17.28-14.378666c-9.557333-3.242667-16.213333-8.021333-20.224-14.421334a29.696 29.696 0 0 1-4.778667-19.712 36.394667 36.394667 0 0 1 25.002667-30.421333 26.197333 26.197333 0 0 0 15.530666-13.226667 37.802667 37.802667 0 0 0 4.181334-19.2 34.005333 34.005333 0 0 0-5.930667-17.322666 17.237333 17.237333 0 0 0-14.890667-7.68H332.544v597.76h572.8a16.938667 16.938667 0 0 0 14.933333-7.68 38.4 38.4 0 0 0 3.498667-37.077334 27.776 27.776 0 0 0-13.653333-15.018666 49.792 49.792 0 0 1-20.778667-17.92 37.546667 37.546667 0 0 1-5.930667-21.546667 35.413333 35.413333 0 0 1 8.405334-20.309333 40.234667 40.234667 0 0 1 22.058666-13.184 25.984 25.984 0 0 0 15.488-12.586667 42.24 42.24 0 0 0-2.944-41.813333 39.168 39.168 0 0 0-17.237333-15.018667c-15.829333-8.021333-23.466667-18.816-22.613333-32.341333 0.682667-13.653333 11.178667-25.088 30.890666-34.730667a30.762667 30.762667 0 0 0 14.336-14.421333 41.685333 41.685333 0 0 0-2.304-40.618667 35.413333 35.413333 0 0 0-17.834666-14.378667 37.461333 37.461333 0 0 1-19.541334-15.530666 37.546667 37.546667 0 0 1-5.888-21.546667 37.888 37.888 0 0 1 8.405334-20.906667zM576 597.333333a42.666667 42.666667 0 1 0 0 85.333334h128a42.666667 42.666667 0 1 0 0-85.333334h-128z'
        fill='currentColor'
      />
    </>
  ),
})

export const Wallet1: typeof Icon = createIcon({
  displayName: 'Wallet1',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M899.413333 779.093333c0 10.794667-1.834667 20.906667-5.546666 30.293334a75.093333 75.093333 0 0 1-39.68 41.386666c-9.088 3.968-19.072 5.973333-29.866667 5.973334H204.8a81.109333 81.109333 0 0 1-73.813333-47.36c-4.266667-9.386667-6.4-19.498667-6.4-30.293334V353.28c0-21.632 7.552-39.978667 22.613333-55.04 15.061333-15.061333 33.408-22.613333 55.04-22.613333h619.52c21.632 0 39.978667 7.552 55.04 22.613333 15.061333 15.061333 22.613333 33.408 22.613333 55.04V469.333333h-193.706666c-21.632 0-39.978667 7.381333-55.04 22.186667-15.061333 14.805333-22.613333 32.981333-22.613334 54.613333 0.554667 14.805333 3.712 27.861333 9.386667 39.253334 4.565333 9.685333 12.074667 18.474667 22.613333 26.453333 10.538667 7.978667 25.728 11.946667 45.653334 11.946667h193.706666v155.306666zM783.36 236.373333H395.946667c30.72-15.914667 59.733333-31.274667 87.04-46.08 23.893333-12.501333 47.488-25.045333 70.826666-37.546666 23.338667-12.501333 41.514667-22.186667 54.613334-29.013334 19.925333-10.794667 37.674667-15.786667 53.333333-14.933333 15.658667 0.853333 28.885333 3.541333 39.68 8.106667 12.501333 6.272 23.338667 14.506667 32.426667 24.746666l49.493333 94.72z m-116.053333 309.76a37.12 37.12 0 0 1 11.093333-27.306666 37.12 37.12 0 0 1 27.306667-11.093334 37.12 37.12 0 0 1 27.306666 11.093334 37.12 37.12 0 0 1 11.093334 27.306666c0 10.794667-3.712 20.053333-11.093334 27.733334a36.437333 36.437333 0 0 1-27.306666 11.52 36.394667 36.394667 0 0 1-27.306667-11.52 38.528 38.528 0 0 1-11.093333-27.733334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Turntable: typeof Icon = createIcon({
  displayName: 'Turntable',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M586.709333 94.72v21.333333a425.386667 425.386667 0 0 1 348.757334 418.56c0 234.88-190.293333 425.386667-425.088 425.386667h-21.333334v-0.554667C264.192 948.352 85.333333 762.325333 85.333333 534.613333a425.386667 425.386667 0 0 1 349.184-418.602666V94.72a9.386667 9.386667 0 0 1 9.386667-9.386667h133.418667a9.386667 9.386667 0 0 1 9.386666 9.386667z m-50.773333 378.325333l103.722667-250.581333a335.616 335.616 0 0 0-111.274667-25.173333l-17.92 45.013333-17.962667-45.056a335.658667 335.658667 0 0 0-111.274666 25.173333l103.722666 250.581334a66.816 66.816 0 0 1 50.986667 0z m-87.125333 36.096L198.4 405.333333a337.066667 337.066667 0 0 0-25.6 129.28c0 45.824 9.130667 89.557333 25.642667 129.408l250.368-103.808a66.986667 66.986667 0 0 1-0.042667-51.072z m36.181333 87.168l-103.68 250.538667c39.765333 16.469333 83.370667 25.6 129.066667 25.6a336.213333 336.213333 0 0 0 129.237333-25.685333l-103.68-250.538667a66.816 66.816 0 0 1-50.944 0.085333z m86.954667-36.138666l250.368 103.765333a337.066667 337.066667 0 0 0 25.6-129.322667 337.066667 337.066667 0 0 0-25.557334-129.237333l-250.368 103.808a66.986667 66.986667 0 0 1 0 50.986667z m-61.44-363.605334l-30.293334-75.946666a240.469333 240.469333 0 0 1 60.501334 0l-30.250667 75.946666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Edit: typeof Icon = createIcon({
  displayName: 'Edit',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M886.912 201.728a42.666667 42.666667 0 0 1 0 60.416l-13.056 13.013333a42.666667 42.666667 0 0 1-60.288 0l-86.4-86.357333a42.666667 42.666667 0 0 1 0-60.373333l13.013333-12.970667a42.666667 42.666667 0 0 1 60.288 0l86.442667 86.272zM119.850667 907.562667a21.333333 21.333333 0 0 1-25.898667-25.856l31.146667-124.501334a21.333333 21.333333 0 0 1 35.797333-9.898666l93.44 93.354666a21.333333 21.333333 0 0 1-9.856 35.797334l-124.629333 31.146666zM678.186667 237.653333a42.666667 42.666667 0 0 0-60.330667 0l-404.437333 404.053334a42.666667 42.666667 0 0 0 0 60.373333l86.4 86.314667a42.666667 42.666667 0 0 0 60.330666 0l404.437334-404.053334a42.666667 42.666667 0 0 0 0-60.330666L678.186667 237.653333zM362.112 881.066667a34.56 34.56 0 0 1 34.56-34.56h553.642667a34.56 34.56 0 1 1 0 69.12H396.629333a34.56 34.56 0 0 1-34.56-34.56z'
        fill='currentColor'
      />
    </>
  ),
})

export const Donation: typeof Icon = createIcon({
  displayName: 'Donation',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M777.557333 265.258667c-17.706667 17.877333-41.984 27.946667-67.285333 27.946666h-201.386667l132.181334-155.733333c8.832-9.472 19.541333-17.152 31.445333-22.442667a94.933333 94.933333 0 0 1 125.013333 46.250667c16.298667 35.456 8.533333 77.226667-19.498666 104.661333l-0.469334-0.682666z m-267.093333 27.946666H307.84c-52.138667 1.28-95.402667-39.381333-96.725333-90.794666-1.28-51.413333 39.893333-94.165333 91.989333-95.402667 15.018667-0.426667 29.909333 2.773333 43.434667 9.216 11.861333 5.290667 22.528 12.970667 31.232 22.442667l132.608 154.538666z m39.210667 57.002667h341.077333c16.213333 0.085333 29.312 12.202667 29.44 27.093333v81.408c0 14.976-13.226667 27.136-29.44 27.136h-342.186667l1.109334-135.637333z m-70.784 0v135.637333H136.234667a30.933333 30.933333 0 0 1-20.906667-7.978666 26.112 26.112 0 0 1-8.661333-19.157334V377.514667c0.128-14.933333 13.312-27.050667 29.568-27.136l342.656-0.170667z m-0.938667 569.770667H207.786667a73.941333 73.941333 0 0 1-73.941334-73.984v-305.237334h344.874667v379.050667l-0.768 0.170667z m415.658667-379.264v305.109333c0 40.874667-33.109333 73.984-73.984 73.984h-271.104v-379.093333h345.088z'
        fill='currentColor'
      />
    </>
  ),
})

export const Wallet: typeof Icon = createIcon({
  displayName: 'Wallet',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M899.413333 779.093333c0 10.794667-1.834667 20.906667-5.546666 30.293334a75.093333 75.093333 0 0 1-39.68 41.386666c-9.088 3.968-19.072 5.973333-29.866667 5.973334H204.8a81.066667 81.066667 0 0 1-73.813333-47.36c-4.266667-9.386667-6.4-19.498667-6.4-30.293334V353.28c0-21.632 7.552-39.978667 22.613333-55.04 15.061333-15.061333 33.408-22.613333 55.04-22.613333h619.52c21.632 0 39.978667 7.552 55.04 22.613333 15.061333 15.061333 22.613333 33.408 22.613333 55.04V469.333333h-193.706666c-21.632 0-39.978667 7.381333-55.04 22.186667-15.061333 14.805333-22.613333 32.981333-22.613334 54.613333 0.554667 14.805333 3.712 27.861333 9.386667 39.253334 4.565333 9.685333 12.074667 18.474667 22.613333 26.453333 10.538667 7.978667 25.728 11.946667 45.653334 11.946667h193.706666v155.306666zM783.36 236.373333H395.946667c30.72-15.914667 59.733333-31.274667 87.04-46.08 23.893333-12.501333 47.488-25.045333 70.826666-37.546666 23.338667-12.501333 41.514667-22.186667 54.613334-29.013334 19.925333-10.794667 37.674667-15.786667 53.333333-14.933333 15.658667 0.853333 28.885333 3.541333 39.68 8.106667 12.501333 6.272 23.338667 14.506667 32.426667 24.746666l49.493333 94.72z m-116.053333 309.76a37.12 37.12 0 0 1 11.093333-27.306666 37.12 37.12 0 0 1 27.306667-11.093334 37.12 37.12 0 0 1 27.306666 11.093334 37.12 37.12 0 0 1 11.093334 27.306666c0 10.794667-3.712 20.053333-11.093334 27.733334a36.437333 36.437333 0 0 1-27.306666 11.52 36.437333 36.437333 0 0 1-27.306667-11.52 38.528 38.528 0 0 1-11.093333-27.733334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Service: typeof Icon = createIcon({
  displayName: 'Service',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 130.688c166.826667 0 305.578667 125.952 325.973333 287.445333h2.56a82.432 82.432 0 0 1 82.005334 77.141334l0.128 4.992v82.133333a82.346667 82.346667 0 0 1-82.133334 82.133333c0 110.592-88.576 201.472-198.272 205.226667l-7.082666 0.085333h-52.053334a82.090667 82.090667 0 1 1-136.277333-91.050666 82.133333 82.133333 0 0 1 136.277333 8.96h52.053334a123.349333 123.349333 0 0 0 123.093333-117.077334l0.128-6.144v-205.354666l-0.128-7.338667C754.346667 319.701333 645.12 212.778667 512 212.778667c-133.034667 0-242.346667 106.922667-246.272 239.061333l-0.128 7.338667v164.266666c0 21.290667-16.384 38.869333-37.12 40.917334l-3.968 0.170666H183.466667a82.432 82.432 0 0 1-82.005334-77.141333l-0.128-4.992v-82.133333a82.432 82.432 0 0 1 77.141334-82.005334L183.466667 418.133333h2.56C206.421333 256.64 345.173333 130.645333 512 130.645333zM469.333333 448a64 64 0 1 1-128 0 64 64 0 0 1 128 0z m149.333334 64a64 64 0 1 0 0-128 64 64 0 0 0 0 128z'
        fill='currentColor'
      />
    </>
  ),
})

export const Refresh: typeof Icon = createIcon({
  displayName: 'Refresh',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M241.493333 204.288a20.608 20.608 0 0 1 4.906667-26.24A425.002667 425.002667 0 0 1 512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667 0 78.933333-21.461333 152.874667-58.794667 216.32-7.978667 13.525333-27.306667 12.586667-34.986667-1.194667l-101.973333-183.466666A21.333333 21.333333 0 0 1 761.6 512h70.4a20.352 20.352 0 0 0 20.650667-21.333333A341.333333 341.333333 0 0 0 296.362667 247.381333c-10.837333 8.832-27.392 6.4-34.176-5.845333l-20.693334-37.248z m541.013334 615.424a20.608 20.608 0 0 1-4.906667 26.197333A424.96 424.96 0 0 1 512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512c0-78.933333 21.461333-152.874667 58.794667-216.32 7.978667-13.525333 27.306667-12.586667 34.986667 1.194667l101.973333 183.466666A21.333333 21.333333 0 0 1 262.4 512H192a20.352 20.352 0 0 0-20.650667 21.333333 341.333333 341.333333 0 0 0 556.288 243.285334c10.837333-8.832 27.392-6.4 34.176 5.845333l20.693334 37.248z'
        fill='currentColor'
      />
    </>
  ),
})

export const Meunl: typeof Icon = createIcon({
  displayName: 'Meunl',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M484.608 256a40.405333 40.405333 0 0 0 0 80.853333h404.181333a40.405333 40.405333 0 0 0 0-80.853333h-404.181333z m0 431.146667a40.405333 40.405333 0 1 0 0 80.853333h404.181333a40.405333 40.405333 0 1 0 0-80.853333h-404.181333z m-255.402667-215.552l100.010667-91.690667a40.405333 40.405333 0 0 0-55.04-59.221333l-175.957333 161.706666a40.405333 40.405333 0 0 0 0 59.221334l175.957333 161.706666a40.405333 40.405333 0 0 0 57.130667-2.133333l2.645333-3.157333a40.448 40.448 0 0 0-4.736-53.973334l-100.010667-91.648h652.373334a40.405333 40.405333 0 1 0 0-80.810666H229.162667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Meunr: typeof Icon = createIcon({
  displayName: 'Meunr',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M529.962667 256a40.405333 40.405333 0 1 1 0 80.853333H125.738667a40.405333 40.405333 0 0 1 0-80.853333h404.224z m0 431.146667a40.405333 40.405333 0 1 1 0 80.853333H125.738667a40.405333 40.405333 0 1 1 0-80.853333h404.224z m255.402666-215.552l-100.010666-91.690667a40.405333 40.405333 0 1 1 55.04-59.221333l175.914666 161.706666a40.405333 40.405333 0 0 1 0 59.221334l-175.914666 161.706666a40.405333 40.405333 0 0 1-57.130667-2.133333l-2.645333-3.157333a40.448 40.448 0 0 1 4.693333-53.973334l100.010667-91.648H133.034667a40.405333 40.405333 0 1 1 0-80.810666h652.330666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Info: typeof Icon = createIcon({
  displayName: 'Info',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m0-85.333334a341.333333 341.333333 0 1 0 0-682.709333A341.333333 341.333333 0 0 0 512 853.333333z'
        fill='currentColor'
      />
      <path
        d='M512 640a42.666667 42.666667 0 0 1 42.666667 42.666667v42.666666a42.666667 42.666667 0 1 1-85.333334 0v-42.666666a42.666667 42.666667 0 0 1 42.666667-42.666667zM512 256a42.666667 42.666667 0 0 1 42.666667 42.666667v256a42.666667 42.666667 0 1 1-85.333334 0V298.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Twitter: typeof Icon = createIcon({
  displayName: 'Twitter',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M382.933333 853.333333c305.92 0 473.258667-246.186667 473.258667-459.690666 0-6.997333-0.170667-13.952-0.469333-20.906667A332.629333 332.629333 0 0 0 938.666667 289.109333a340.053333 340.053333 0 0 1-95.488 25.429334 163.114667 163.114667 0 0 0 73.130666-89.386667 338.986667 338.986667 0 0 1-105.642666 39.253333A168.405333 168.405333 0 0 0 689.28 213.333333c-91.861333 0-166.357333 72.362667-166.357333 161.578667 0 12.629333 1.493333 24.96 4.352 36.821333a476.928 476.928 0 0 1-342.826667-168.789333 157.354667 157.354667 0 0 0-22.528 81.194667c0 56.021333 29.354667 105.557333 73.984 134.485333a168.448 168.448 0 0 1-75.306667-20.224l-0.042666 2.048c0 78.293333 57.344 143.616 133.418666 158.421333a170.837333 170.837333 0 0 1-75.093333 2.773334c21.162667 64.170667 82.56 110.890667 155.349333 112.213333a339.968 339.968 0 0 1-206.549333 69.12c-13.397333 0-26.666667-0.725333-39.68-2.218667A481.024 481.024 0 0 0 382.933333 853.333333z'
        fill='currentColor'
      />
    </>
  ),
})

export const More: typeof Icon = createIcon({
  displayName: 'More',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path d='M682.666667 512l-256 256V256l256 256z' fill='currentColor' />
    </>
  ),
})

export const Mute: typeof Icon = createIcon({
  displayName: 'Mute',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M768 554.666667V159.573333a42.666667 42.666667 0 0 0-64.170667-36.821333L469.333333 256l298.666667 298.666667zM277.162667 652.373333A42.666667 42.666667 0 0 1 256 615.424v-206.933333a42.666667 42.666667 0 0 1 21.162667-36.906667l48.512-28.288-142.506667-142.506667a42.666667 42.666667 0 0 1 60.330667-60.330666l682.666666 682.666666a42.666667 42.666667 0 0 1-60.330666 60.330667L768 785.664v78.72a42.666667 42.666667 0 0 1-64.170667 36.821333l-426.666666-248.874666zM128 597.376a42.666667 42.666667 0 0 0 85.333333 0v-170.666667a42.666667 42.666667 0 1 0-85.333333 0v170.666667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Finger: typeof Icon = createIcon({
  displayName: 'Finger',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M412.584989 3.343578a117.189915 117.189915 0 0 1 117.189914 117.189914V248.765054h26.861822c35.027073 0 66.574635 15.077879 88.425961 39.109698h58.084629c39.573633 0 74.693493 19.206898 96.452032 48.805934h50.058558a119.648769 119.648769 0 0 1 119.648769 119.695163v316.171523a119.695162 119.695162 0 0 1-68.383981 108.096794v104.338923a39.063305 39.063305 0 0 1-39.063305 39.063304H451.648294a39.063305 39.063305 0 0 1-39.063305-39.063304v-118.396145l-327.259564-181.398483a117.189915 117.189915 0 0 1 113.664011-205.01276l96.359245 53.445282V120.533492A117.189915 117.189915 0 0 1 412.584989 3.343578z'
        fill='currentColor'
      />
      <path
        d='M465.983877 120.533492v191.976195h90.652848c16.330503 0 30.99084 6.959021 41.290191 18.279028l19.021324 20.83067h86.199075c18.418209 0 34.795105 8.81476 45.048063 22.825589l19.114111 25.980345h82.348416c30.85166 0 55.857742 25.052476 55.857742 55.857743v316.217917c0 22.17608-12.990173 41.475766-31.965103 50.522493l-36.418877 17.304765v119.880737H476.329622v-131.200744l-360.106144-199.631118a53.398888 53.398888 0 0 1 51.775117-93.436456l191.141112 105.916301V120.533492a53.398888 53.398888 0 1 1 106.797776 0z m-426.356024 405.293387a117.189915 117.189915 0 0 0 45.697572 159.361582l327.259564 181.398483v118.303358c0 21.619359 17.49034 39.109698 39.063305 39.109698h410.211094a39.063305 39.063305 0 0 0 39.063305-39.063305V880.644166a119.695162 119.695162 0 0 0 68.383981-108.143187V456.283062a119.648769 119.648769 0 0 0-119.695163-119.648769h-50.012164a119.463195 119.463195 0 0 0-96.498426-48.805934h-57.991842a119.324014 119.324014 0 0 0-88.472354-39.109699h-26.908215V120.533492a117.189915 117.189915 0 1 0-234.379829 0v413.041097l-96.359245-53.445282a117.189915 117.189915 0 0 0-159.361583 45.697572zM535.249333 513.671789a31.872316 31.872316 0 1 0-63.791026 0v127.582053a31.91871 31.91871 0 0 0 63.791026 0V513.671789z m127.582053 0a31.872316 31.872316 0 1 0-63.791026 0v127.582053a31.872316 31.872316 0 1 0 63.791026 0V513.671789z m95.709736-31.91871c17.62952 0 31.872316 14.28919 31.872317 31.91871v127.582053a31.872316 31.872316 0 1 1-63.791027 0V513.671789c0-17.62952 14.28919-31.91871 31.91871-31.91871z'
        fill='currentColor'
      />
    </>
  ),
})

export const RangeArrow: typeof Icon = createIcon({
  displayName: 'RangeArrow',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M560.085333 364.373333a60.16 60.16 0 0 1 84.48-10.24l270.933334 212.138667c45.013333 35.285333 20.053333 107.605333-37.12 107.605333H145.493333a60.16 60.16 0 0 1 0-120.405333h558.336l-133.504-104.533333a60.202667 60.202667 0 0 1-14.549333-78.293334l4.266667-6.229333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Checkbox: typeof Icon = createIcon({
  displayName: 'Checkbox',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M768 213.333333a42.666667 42.666667 0 0 1 42.666667 42.666667v512a42.666667 42.666667 0 0 1-42.666667 42.666667H256a42.666667 42.666667 0 0 1-42.666667-42.666667V256a42.666667 42.666667 0 0 1 42.666667-42.666667h512zM256 128a128 128 0 0 0-128 128v512a128 128 0 0 0 128 128h512a128 128 0 0 0 128-128V256a128 128 0 0 0-128-128H256z'
        fill='currentColor'
      />
    </>
  ),
})

export const Close: typeof Icon = createIcon({
  displayName: 'Close',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M315.306667 230.826667a59.733333 59.733333 0 0 0-84.48 84.48L427.52 512l-196.693333 196.693333a59.733333 59.733333 0 1 0 84.48 84.48L512 596.48l196.693333 196.693333a59.733333 59.733333 0 1 0 84.48-84.48L596.48 512l196.693333-196.693333a59.733333 59.733333 0 1 0-84.48-84.48L512 427.52 315.306667 230.826667z'
        fill='currentColor'
      />
    </>
  ),
})

export const DarrowLeft: typeof Icon = createIcon({
  displayName: 'DarrowLeft',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M499.498667 225.834667a42.666667 42.666667 0 0 0-60.330667 0l-256 256a42.666667 42.666667 0 0 0 0 60.330666l256 256a42.666667 42.666667 0 0 0 60.330667-60.330666L273.664 512l225.834667-225.834667a42.666667 42.666667 0 0 0 0-60.330666z'
        fill='currentColor'
      />
      <path
        d='M840.832 225.834667a42.666667 42.666667 0 0 0-60.330667 0l-256 256a42.666667 42.666667 0 0 0 0 60.330666l256 256a42.666667 42.666667 0 0 0 60.330667-60.330666L614.997333 512l225.834667-225.834667a42.666667 42.666667 0 0 0 0-60.330666z'
        fill='currentColor'
      />
    </>
  ),
})

export const CheckboxSelected: typeof Icon = createIcon({
  displayName: 'CheckboxSelected',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M687.530667 481.706667a42.666667 42.666667 0 0 0-52.394667-67.413334l-158.762667 123.52-59.050666-73.813333a42.666667 42.666667 0 1 0-66.645334 53.333333l85.333334 106.666667a42.666667 42.666667 0 0 0 59.52 6.997333l192-149.333333z'
        fill='currentColor'
      />
      <path
        d='M128 256a128 128 0 0 1 128-128h512a128 128 0 0 1 128 128v512a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V256z m128-42.666667a42.666667 42.666667 0 0 0-42.666667 42.666667v512a42.666667 42.666667 0 0 0 42.666667 42.666667h512a42.666667 42.666667 0 0 0 42.666667-42.666667V256a42.666667 42.666667 0 0 0-42.666667-42.666667H256z'
        fill='currentColor'
      />
    </>
  ),
})

export const DarrowRight: typeof Icon = createIcon({
  displayName: 'DarrowRight',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M524.501333 225.834667a42.666667 42.666667 0 0 1 60.330667 0l256 256a42.666667 42.666667 0 0 1 0 60.330666l-256 256a42.666667 42.666667 0 0 1-60.330667-60.330666L750.336 512l-225.834667-225.834667a42.666667 42.666667 0 0 1 0-60.330666z'
        fill='currentColor'
      />
      <path
        d='M183.168 225.834667a42.666667 42.666667 0 0 1 60.330667 0l256 256a42.666667 42.666667 0 0 1 0 60.330666l-256 256a42.666667 42.666667 0 0 1-60.330667-60.330666L409.002667 512 183.168 286.165333a42.666667 42.666667 0 0 1 0-60.330666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Reach: typeof Icon = createIcon({
  displayName: 'Reach',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M758.101333 289.706667a4.266667 4.266667 0 0 0-6.016 0L439.466667 602.282667a4.266667 4.266667 0 0 1-6.058667 0l-153.216-153.258667a4.266667 4.266667 0 0 0-6.058667 0L207.829333 515.413333a4.266667 4.266667 0 0 0 0 6.016l225.621334 225.706667a4.266667 4.266667 0 0 0 6.058666 0l384.981334-384.981333a4.266667 4.266667 0 0 0 0-6.058667L758.101333 289.706667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Delete: typeof Icon = createIcon({
  displayName: 'Delete',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M725.333333 425.386667c0-22.784-19.2-41.386667-42.666666-41.386667-23.637333 0-42.666667 18.602667-42.666667 41.386667v343.893333c0 22.826667 19.114667 41.386667 42.666667 41.386667 23.466667 0 42.666667-18.56 42.666666-41.386667V425.386667zM554.666667 425.386667c0-22.784-19.2-41.386667-42.666667-41.386667-23.594667 0-42.666667 18.602667-42.666667 41.386667v343.893333c0 22.826667 19.157333 41.386667 42.666667 41.386667 23.466667 0 42.666667-18.56 42.666667-41.386667V425.386667z m-170.666667 0C384 402.602667 364.8 384 341.248 384 317.866667 384 298.666667 402.602667 298.666667 425.386667v343.893333c0 22.826667 19.2 41.386667 42.666666 41.386667 23.637333 0 42.666667-18.56 42.666667-41.386667V425.386667zM810.666667 340.266667v514.005333A42.24 42.24 0 0 1 768 896H256a42.24 42.24 0 0 1-42.666667-41.728V298.666667h597.333334v41.6zM170.666667 213.248c0-23.552 19.114667-42.752 42.666666-42.752h213.376V128c0-23.594667 19.029333-42.624 42.666667-42.624h85.333333a42.666667 42.666667 0 0 1 42.666667 42.666667v42.666666H810.666667a42.666667 42.666667 0 0 1 42.666666 42.624V256H170.666667V213.248z'
        fill='currentColor'
      />
    </>
  ),
})

export const Safe: typeof Icon = createIcon({
  displayName: 'Safe',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M505.941333 674.56l-54.570666 54.528L396.8 674.56l-136.448-136.405333 54.570667-54.613334 136.448 136.448 300.202666-300.202666 54.613334 54.613333-300.245334 300.16z m55.808-528.213333c-24.106667-22.485333-71.509333-22.485333-95.573333 0-50.474667 47.104-143.061333 105.002667-288.426667 95.573333-26.24-1.706667-49.792 18.090667-49.578666 44.373333 2.005333 244.437333 29.184 505.856 385.792 652.373334 356.48-146.474667 383.744-408.661333 385.749333-652.373334 0.256-26.282667-23.338667-46.08-49.536-44.373333-145.365333 9.429333-237.994667-48.469333-288.426667-95.573333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Prompt: typeof Icon = createIcon({
  displayName: 'Prompt',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M612.992 495.36l-31.146667 35.242667a113.322667 113.322667 0 0 0-21.76 38.101333c-4.266667 13.141333-6.656 30.336-7.125333 51.626667h-93.013333c0-35.072 3.413333-62.890667 10.325333-83.541334 6.826667-20.608 19.157333-40.32 36.949333-59.050666 18.773333-20.821333 31.232-37.802667 37.461334-51.072 6.272-13.226667 9.386667-26.624 9.386666-40.106667 0-41.813333-13.482667-62.72-40.490666-62.72-11.989333 0-22.016 5.802667-29.994667 17.322667-8.021333 11.477333-12.245333 26.965333-12.8 46.506666H364.714667c0.469333-48.512 14.08-86.186667 40.661333-112.938666 26.624-26.752 62.72-40.192 108.245333-40.192 46.506667 0 82.645333 13.013333 108.373334 38.869333 25.770667 25.856 38.656 62.122667 38.656 108.629333 0 38.528-15.872 76.288-47.616 113.322667m-62.677334 281.088c-10.496 11.008-24.618667 16.512-42.368 16.512-17.493333 0-31.488-5.504-41.984-16.512s-15.786667-24.746667-15.786666-41.301333c0-16.981333 5.461333-30.890667 16.341333-41.6 10.88-10.752 24.704-16.213333 41.429333-16.213334 17.237333 0 31.232 5.504 41.984 16.384s16.128 24.661333 16.128 41.429334c0 16.554667-5.248 30.293333-15.744 41.301333M512 85.333333c-235.648 0-426.666667 191.018667-426.666667 426.666667 0 235.605333 191.018667 426.666667 426.666667 426.666667s426.666667-191.061333 426.666667-426.666667c0-235.648-191.018667-426.666667-426.666667-426.666667'
        fill='currentColor'
      />
    </>
  ),
})

export const Notice: typeof Icon = createIcon({
  displayName: 'Notice',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M911.616 314.24a42.666667 42.666667 0 0 0-42.666667-73.898667l-73.898666 42.666667a42.666667 42.666667 0 0 0 42.666666 73.898667l73.898667-42.666667zM810.666667 554.709333h85.333333a42.666667 42.666667 0 0 0 0-85.333333h-85.333333a42.666667 42.666667 0 0 0 0 85.333333z m100.949333 155.008l-73.898667-42.666666a42.666667 42.666667 0 0 0-42.666666 73.898666l73.898666 42.666667a42.666667 42.666667 0 0 0 42.666667-73.898667zM213.333333 615.509333a42.666667 42.666667 0 0 0 21.162667 36.821334l426.666667 248.917333A42.666667 42.666667 0 0 0 725.333333 864.384V159.616a42.666667 42.666667 0 0 0-64.170666-36.864l-426.666667 248.917333A42.666667 42.666667 0 0 0 213.333333 408.490667v207.018666zM85.333333 597.333333a42.666667 42.666667 0 1 0 85.333334 0v-170.666666a42.666667 42.666667 0 1 0-85.333334 0v170.666666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Over18: typeof Icon = createIcon({
  displayName: 'Over18',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M334.933333 509.994667a135.850667 135.850667 0 0 1-25.002666-26.709334c-15.189333-21.333333-22.784-47.018667-22.784-76.970666 0-30.976 7.466667-57.472 22.442666-79.573334 14.976-22.101333 35.754667-39.424 62.293334-51.968 26.581333-12.501333 57.173333-18.773333 91.733333-18.773333 34.986667 0 65.706667 6.272 92.032 18.773333 26.325333 12.544 47.018667 29.866667 61.994667 51.968 14.933333 22.101333 22.442667 48.64 22.442666 79.573334 0 29.952-7.509333 55.594667-22.485333 76.970666a132.309333 132.309333 0 0 1-25.045333 26.88c15.616 10.24 28.586667 22.613333 38.997333 37.248 16.213333 22.826667 24.32 50.474667 24.32 82.901334 0 32.896-7.978667 61.525333-24.021333 85.845333-16 24.32-38.485333 43.093333-67.370667 56.32-28.885333 13.269333-62.506667 19.925333-100.864 19.925333-38.4 0-71.893333-6.656-100.565333-19.882666-28.672-13.269333-51.114667-32.085333-67.370667-56.405334-16.213333-24.32-24.32-52.906667-24.32-85.802666 0-32.426667 8.106667-60.074667 24.32-82.901334 10.453333-14.72 23.552-27.178667 39.253333-37.418666z m128.682667 179.968c20.224 0 36.352-5.632 48.384-16.938667 12.032-11.264 18.005333-27.008 18.005333-47.146667 0-19.626667-5.973333-35.242667-18.005333-46.805333-12.032-11.52-28.16-17.28-48.384-17.28-20.224 0-36.352 5.76-48.384 17.28-12.032 11.562667-18.048 27.178667-18.048 46.805333 0 20.138667 6.016 35.84 18.048 47.146667 12.032 11.306667 28.16 16.938667 48.384 16.938667z m38.570667-237.568c9.728-9.6 14.549333-22.741333 14.549333-39.424 0-17.664-4.949333-31.189333-14.848-40.533334-9.898667-9.301333-22.656-13.994667-38.272-13.994666s-28.245333 4.693333-37.973333 13.994666c-9.685333 9.344-14.506667 22.869333-14.506667 40.533334 0 16.682667 4.821333 29.866667 14.506667 39.424 9.728 9.557333 22.357333 14.378667 37.973333 14.378666 16.042667 0 28.885333-4.821333 38.570667-14.378666zM82.218667 782.08V379.050667H0V266.325333h207.445333V782.08H82.218667zM819.712 699.562667v-121.6h-107.52v-107.52h107.52v-121.6h97.408v121.6H1024v107.52h-106.88v121.6h-97.408z'
        fill='currentColor'
      />
    </>
  ),
})

export const Add: typeof Icon = createIcon({
  displayName: 'Add',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 219.434667a48.768 48.768 0 0 0-48.768 48.725333v195.072H268.202667a48.768 48.768 0 0 0 0 97.536h195.029333v195.029333a48.768 48.768 0 0 0 97.536 0v-195.029333h195.029333a48.768 48.768 0 1 0 0-97.536h-195.029333V268.16A48.768 48.768 0 0 0 512 219.434667z'
        fill='currentColor'
      />
    </>
  ),
})

export const ArrowRight1: typeof Icon = createIcon({
  displayName: 'ArrowRight1',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M353.834667 225.834667a42.666667 42.666667 0 0 1 60.330666 0l256 256a42.666667 42.666667 0 0 1 0 60.330666l-256 256a42.666667 42.666667 0 0 1-60.330666-60.330666L579.669333 512 353.834667 286.165333a42.666667 42.666667 0 0 1 0-60.330666z'
        fill='currentColor'
      />
    </>
  ),
})

export const ArrowUp: typeof Icon = createIcon({
  displayName: 'ArrowUp',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M791.893333 663.893333a64 64 0 0 1-90.453333 0L512 474.538667l-189.44 189.44a64 64 0 0 1-90.453333-90.538667l234.666666-234.666667a64 64 0 0 1 90.453334 0l234.666666 234.666667a64 64 0 0 1 0 90.538667z'
        fill='currentColor'
      />
    </>
  ),
})

export const ArrowDown: typeof Icon = createIcon({
  displayName: 'ArrowDown',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M232.106667 338.773333a64 64 0 0 1 90.453333 0L512 528.128l189.44-189.44a64 64 0 0 1 90.453333 90.538667l-234.666666 234.666666a64 64 0 0 1-90.453334 0l-234.666666-234.666666a64 64 0 0 1 0-90.538667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Code: typeof Icon = createIcon({
  displayName: 'Code',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M384 298.666667a42.666667 42.666667 0 0 0 0 85.333333h256a42.666667 42.666667 0 1 0 0-85.333333H384zM341.333333 512a42.666667 42.666667 0 0 1 42.666667-42.666667h256a42.666667 42.666667 0 1 1 0 85.333334H384a42.666667 42.666667 0 0 1-42.666667-42.666667zM384 640a42.666667 42.666667 0 1 0 0 85.333333h256a42.666667 42.666667 0 1 0 0-85.333333H384z'
        fill='currentColor'
      />
      <path
        d='M170.666667 213.333333a85.333333 85.333333 0 0 1 85.333333-85.333333h512a85.333333 85.333333 0 0 1 85.333333 85.333333v597.333334a85.333333 85.333333 0 0 1-85.333333 85.333333H256a85.333333 85.333333 0 0 1-85.333333-85.333333V213.333333z m85.333333 0v597.333334h512V213.333333H256z'
        fill='currentColor'
      />
    </>
  ),
})

export const ArrowLeft: typeof Icon = createIcon({
  displayName: 'ArrowLeft',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M670.165333 225.834667a42.666667 42.666667 0 0 0-60.330666 0l-256 256a42.666667 42.666667 0 0 0 0 60.330666l256 256a42.666667 42.666667 0 0 0 60.330666-60.330666L444.330667 512l225.834666-225.834667a42.666667 42.666667 0 0 0 0-60.330666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Reduce: typeof Icon = createIcon({
  displayName: 'Reduce',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M755.797333 463.232H268.202667c-29.269333 0-48.768 19.541333-48.768 48.768 0 29.269333 19.498667 48.768 48.768 48.768h487.594666c29.269333 0 48.768-19.498667 48.768-48.768 0-29.226667-19.498667-48.768-48.768-48.768z'
        fill='currentColor'
      />
    </>
  ),
})

export const Loading: typeof Icon = createIcon({
  displayName: 'Loading',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 162.901333a349.098667 349.098667 0 0 0 0 698.197334c191.914667 0 349.098667-157.184 349.098667-349.098667A38.826667 38.826667 0 1 1 938.666667 512c0 234.752-191.914667 426.666667-426.666667 426.666667-235.648 0-426.666667-191.018667-426.666667-426.666667S276.352 85.333333 512 85.333333a38.826667 38.826667 0 1 1 0 77.568z'
        fill='currentColor'
      />
    </>
  ),
})

export const Amplify: typeof Icon = createIcon({
  displayName: 'Amplify',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M426.666667 128a42.666667 42.666667 0 1 1 0 85.333333H213.333333v213.333334a42.666667 42.666667 0 0 1-85.333333 0V213.333333a85.333333 85.333333 0 0 1 85.333333-85.333333h213.333334z m0 768a42.666667 42.666667 0 0 0 0-85.333333H213.333333v-213.333334a42.666667 42.666667 0 0 0-85.333333 0v213.333334a85.333333 85.333333 0 0 0 85.333333 85.333333h213.333334z m170.666666-768a42.666667 42.666667 0 1 0 0 85.333333h213.333334v213.333334a42.666667 42.666667 0 1 0 85.333333 0V213.333333a85.333333 85.333333 0 0 0-85.333333-85.333333h-213.333334z m0 768a42.666667 42.666667 0 1 1 0-85.333333h213.333334v-213.333334a42.666667 42.666667 0 1 1 85.333333 0v213.333334a85.333333 85.333333 0 0 1-85.333333 85.333333h-213.333334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Display: typeof Icon = createIcon({
  displayName: 'Display',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M605.781333 372.565333A152.490667 152.490667 0 0 0 512 339.84c-16.426667 0-32.256 2.645333-47.146667 7.552 11.818667 5.717333 22.186667 14.464 30.165334 25.429333 7.978667 10.965333 13.397333 23.893333 15.744 37.546667 2.304 13.738667 1.536 27.861333-2.304 41.173333-3.84 13.312-10.666667 25.429333-19.84 35.285334a79.232 79.232 0 0 1-32.768 21.333333c-12.373333 4.138667-25.472 4.992-38.229334 2.474667a77.44 77.44 0 0 1-34.944-16.938667 85.461333 85.461333 0 0 1-23.594666-32.469333 184.661333 184.661333 0 0 0 1.365333 106.112 171.690667 171.690667 0 0 0 58.88 85.077333 152.32 152.32 0 0 0 94.122667 31.786667 152.661333 152.661333 0 0 0 93.482666-33.621334 172.330667 172.330667 0 0 0 57.472-86.229333c10.24-34.56 10.069333-71.68-0.426666-106.112a172.032 172.032 0 0 0-58.197334-85.674667z'
        fill='currentColor'
      />
      <path
        d='M896 512c39.253333 16.810667 39.210667 16.853333 39.168 16.896v0.085333l-0.128 0.256-0.426667 0.853334-1.28 2.986666a646.016 646.016 0 0 1-24.277333 46.72 714.24 714.24 0 0 1-76.672 109.312C764.672 768.128 657.92 853.333333 512 853.333333c-145.92 0-252.672-85.205333-320.426667-164.266666a714.368 714.368 0 0 1-95.872-145.493334 438.826667 438.826667 0 0 1-6.357333-13.44l-0.384-0.853333-0.085333-0.298667-0.085334-0.170666L81.578667 512l7.210666-16.810667L128 512c-39.253333-16.810667-39.210667-16.853333-39.168-16.896v-0.085333l0.128-0.256 0.426667-0.853334a332.928 332.928 0 0 1 6.314666-13.525333A714.410667 714.410667 0 0 1 191.573333 334.933333C259.328 255.872 366.08 170.666667 512 170.666667c145.877333 0 252.672 85.205333 320.426667 164.266666a714.24 714.24 0 0 1 95.872 145.493334c2.176 4.437333 3.84 7.978667 4.992 10.496l1.365333 2.986666 0.384 0.853334 0.128 0.256v0.128l7.253333 16.853333-7.210666 16.810667L896 512z m-706.986667-25.514667c-5.674667 9.984-10.24 18.645333-13.738666 25.514667a629.162667 629.162667 0 0 0 81.109333 121.6C316.672 703.829333 401.92 768 512 768c110.122667 0 195.328-64.128 255.573333-134.4A629.248 629.248 0 0 0 848.768 512a629.205333 629.205333 0 0 0-81.109333-121.6C707.328 320.170667 622.08 256 512 256 401.92 256 316.672 320.128 256.426667 390.4a629.077333 629.077333 0 0 0-67.413334 96.085333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Question: typeof Icon = createIcon({
  displayName: 'Question',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m0-85.333334a341.333333 341.333333 0 1 0 0-682.709333A341.333333 341.333333 0 0 0 512 853.333333z'
        fill='currentColor'
      />
      <path
        d='M448 405.290667V405.333333a42.666667 42.666667 0 1 1-85.333333 0c0-20.181333 8.106667-51.413333 30.805333-78.208C417.792 298.325333 456.661333 277.333333 512 277.333333c41.685333 0 79.786667 14.08 107.52 41.813334 27.733333 27.733333 41.813333 65.834667 41.813333 107.52 0 32.554667-13.952 68.821333-37.888 96.981333-17.621333 20.693333-41.813333 38.4-71.850666 46.933333A42.666667 42.666667 0 0 1 469.333333 554.666667v-21.333334a42.666667 42.666667 0 0 1 42.666667-42.666666c19.541333 0 34.944-8.789333 46.421333-22.272 12.330667-14.506667 17.578667-31.573333 17.578667-41.728 0-22.314667-7.253333-37.546667-16.853333-47.146667C549.589333 369.92 534.314667 362.666667 512 362.666667c-31.701333 0-46.165333 11.008-53.376 19.541333-4.181333 4.906667-6.954667 10.24-8.661333 15.104-1.621333 4.48-1.92 7.466667-1.962667 7.978667zM512 640a42.666667 42.666667 0 0 1 42.666667 42.666667v42.666666a42.666667 42.666667 0 1 1-85.333334 0v-42.666666a42.666667 42.666667 0 0 1 42.666667-42.666667z'
        fill='currentColor'
      />
    </>
  ),
})

export const EmptyBox: typeof Icon = createIcon({
  displayName: 'EmptyBox',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M734.250667 180.650667A106.666667 106.666667 0 0 0 689.066667 170.666667H334.848a106.666667 106.666667 0 0 0-81.749333 38.144L101.290667 389.930667a67.84 67.84 0 0 0-15.786667 40.832H85.333333v310.314666a96.981333 96.981333 0 0 0 96.981334 96.981334h659.370666A96.981333 96.981333 0 0 0 938.666667 741.077333v-310.314666h-0.213334a67.882667 67.882667 0 0 0-15.786666-40.789334l-151.765334-181.162666a106.666667 106.666667 0 0 0-36.693333-28.16z m146.090666 308.309333v21.077333h0.128v231.04a38.826667 38.826667 0 0 1-38.784 38.784H182.314667l-2.901334-0.085333a38.826667 38.826667 0 0 1-35.882666-38.698667v-231.04h0.085333v-21.077333h135.68v19.370667a96.981333 96.981333 0 0 0 89.770667 96.725333l2.133333 0.128 5.034667 0.128h271.530666l4.181334-0.085333a96.981333 96.981333 0 0 0 92.8-96.853334v-19.413333h135.594666z m-0.426666-58.197333H725.333333a38.784 38.784 0 0 0-38.826666 38.826666v38.741334a38.784 38.784 0 0 1-38.741334 38.826666H376.234667l-2.901334-0.128a38.784 38.784 0 0 1-35.84-38.698666v-38.784a38.826667 38.826667 0 0 0-38.826666-38.784H144a9.685333 9.685333 0 0 1 1.877333-3.413334L297.728 246.186667a48.469333 48.469333 0 0 1 37.12-17.322667h354.261333a48.469333 48.469333 0 0 1 37.162667 17.322667l151.808 181.12c0.853333 1.024 1.493333 2.176 1.877333 3.456z'
        fill='currentColor'
      />
    </>
  ),
})

export const Email1: typeof Icon = createIcon({
  displayName: 'Email1',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M213.333333 170.666667a128 128 0 0 0-128 128v426.666666a128 128 0 0 0 128 128h597.333334a128 128 0 0 0 128-128V298.666667a128 128 0 0 0-128-128H213.333333zM170.666667 309.333333l315.733333 236.8a42.666667 42.666667 0 0 0 51.2 0L853.333333 309.333333V725.333333a42.666667 42.666667 0 0 1-42.666666 42.666667H213.333333a42.666667 42.666667 0 0 1-42.666666-42.666667V309.333333zM782.208 256L512 458.666667 241.792 256h540.416z'
        fill='currentColor'
      />
    </>
  ),
})

export const Hide: typeof Icon = createIcon({
  displayName: 'Hide',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M823.168 140.501333a42.666667 42.666667 0 1 1 60.330667 60.330667l-682.666667 682.666667a42.666667 42.666667 0 0 1-60.330667-60.330667l91.392-91.392c-14.677333-14.08-28.117333-28.458667-40.277333-42.666667a714.368 714.368 0 0 1-95.914667-145.493333 438.826667 438.826667 0 0 1-6.357333-13.482667l-0.384-0.853333-0.085333-0.298667-0.085334-0.170666 36.565334-15.701334-31.744 13.653334-4.821334 2.048L81.578667 512l7.210666-16.810667L128 512c-39.253333-16.810667-39.210667-16.853333-39.168-16.896v-0.085333l0.128-0.256 0.426667-0.853334a332.928 332.928 0 0 1 6.314666-13.525333A714.410667 714.410667 0 0 1 191.573333 334.933333C259.328 255.872 366.08 170.666667 512 170.666667c84.181333 0 155.306667 28.373333 213.461333 67.541333l97.706667-97.706667zM663.722667 299.946667C619.904 273.365333 569.301333 256 512 256 401.92 256 316.672 320.128 256.426667 390.4A629.077333 629.077333 0 0 0 175.232 512a629.162667 629.162667 0 0 0 81.109333 121.6c11.093333 12.928 23.04 25.642667 35.84 37.802667l72.746667-72.704a170.666667 170.666667 0 0 1 233.728-233.728l65.024-65.024zM502.528 682.410667a170.666667 170.666667 0 0 0 179.882667-179.882667l-179.882667 179.882667z'
        fill='currentColor'
      />
      <path
        d='M363.264 821.717333l66.218667-66.218666A277.632 277.632 0 0 0 512 768c110.122667 0 195.328-64.128 255.573333-134.4A629.248 629.248 0 0 0 848.768 512a638.08 638.08 0 0 0-68.949333-106.837333l60.672-60.672a719.957333 719.957333 0 0 1 87.893333 135.893333c2.133333 4.437333 3.84 8.021333 4.949333 10.538667l1.365334 2.986666 0.384 0.853334 0.128 0.256v0.128L896 512c39.253333 16.810667 39.210667 16.853333 39.168 16.896v0.085333l-0.128 0.256-0.426667 0.853334-1.28 2.986666a646.016 646.016 0 0 1-24.277333 46.72 714.24 714.24 0 0 1-76.672 109.312C764.672 768.128 657.92 853.333333 512 853.333333a364.928 364.928 0 0 1-148.736-31.616z'
        fill='currentColor'
      />
      <path
        d='M896 512c39.253333-16.810667 39.210667-16.810667 39.210667-16.853333l7.210666 16.853333-7.210666 16.810667L896 512z'
        fill='currentColor'
      />
    </>
  ),
})

export const PromptFail: typeof Icon = createIcon({
  displayName: 'PromptFail',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M738.261333 346.026667L677.973333 285.696 512 451.669333l-165.973333-165.973333L285.781333 346.026667 451.669333 512l-165.973333 165.930667 60.373333 60.330666L512 572.288l165.973333 165.973333 60.288-60.373333L572.330667 512l165.973333-165.930667z'
        fill='currentColor'
      />
      <path
        d='M938.666667 512c0 235.648-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667z m-42.666667 0a384 384 0 1 0-768 0 384 384 0 0 0 768 0z'
        fill='currentColor'
      />
    </>
  ),
})

export const PromptSuccess: typeof Icon = createIcon({
  displayName: 'PromptSuccess',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M439.765333 612.138667l288.938667-288.938667 65.664 65.706667-354.602667 354.56L229.632 533.333333l65.706667-65.664 144.426666 144.469334z'
        fill='currentColor'
      />
      <path
        d='M938.666667 512c0-235.648-191.018667-426.666667-426.666667-426.666667S85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667 426.666667-191.018667 426.666667-426.666667z m-42.666667 0a384 384 0 1 1-768 0 384 384 0 0 1 768 0z'
        fill='currentColor'
      />
    </>
  ),
})

export const Lock: typeof Icon = createIcon({
  displayName: 'Lock',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M554.666667 512a42.666667 42.666667 0 1 0-85.333334 0v85.333333a42.666667 42.666667 0 1 0 85.333334 0v-85.333333z'
        fill='currentColor'
      />
      <path
        d='M896 469.333333a128 128 0 0 0-128-128A256 256 0 0 0 256 341.333333a128 128 0 0 0-128 128v298.666667a128 128 0 0 0 128 128h512a128 128 0 0 0 128-128v-298.666667z m-384-298.666666a170.666667 170.666667 0 0 1 170.666667 170.666666H341.333333a170.666667 170.666667 0 0 1 170.666667-170.666666z m-256 256h512a42.666667 42.666667 0 0 1 42.666667 42.666666v298.666667a42.666667 42.666667 0 0 1-42.666667 42.666667H256a42.666667 42.666667 0 0 1-42.666667-42.666667v-298.666667a42.666667 42.666667 0 0 1 42.666667-42.666666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Detail: typeof Icon = createIcon({
  displayName: 'Detail',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M213.333333 85.333333a85.333333 85.333333 0 0 0-85.333333 85.333334v682.666666a85.333333 85.333333 0 0 0 85.333333 85.333334h597.333334a85.333333 85.333333 0 0 0 85.333333-85.333334V170.666667a85.333333 85.333333 0 0 0-85.333333-85.333334H213.333333z m128 213.333334h341.333334a42.666667 42.666667 0 1 1 0 85.333333H341.333333a42.666667 42.666667 0 0 1 0-85.333333z m-42.666666 213.333333a42.666667 42.666667 0 0 1 42.666666-42.666667h298.666667a42.666667 42.666667 0 1 1 0 85.333334H341.333333a42.666667 42.666667 0 0 1-42.666666-42.666667z m42.666666 128h85.333334a42.666667 42.666667 0 1 1 0 85.333333H341.333333a42.666667 42.666667 0 1 1 0-85.333333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Copy: typeof Icon = createIcon({
  displayName: 'Copy',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M229.461333 203.52h425.258667a96.298667 96.298667 0 0 1 96 96v564.48a96.256 96.256 0 0 1-96 96H229.461333a96.085333 96.085333 0 0 1-96-96V299.52a96.085333 96.085333 0 0 1 96-96z'
        fill='currentColor'
      />
      <path
        d='M341.632 96a32 32 0 0 1 32-32h416.810667a100.266667 100.266667 0 0 1 100.181333 100.181333V720.213333a32 32 0 0 1-64 0V164.181333A36.266667 36.266667 0 0 0 790.442667 128h-416.853334a32 32 0 0 1-32-32z'
        fill='currentColor'
      />
    </>
  ),
})

export const Crown: typeof Icon = createIcon({
  displayName: 'Crown',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M856.533333 283.733333a62.890667 62.890667 0 0 0-69.717333 14.250667l-82.773333 84.309333-146.773334-149.845333a63.061333 63.061333 0 0 0-90.496 0L320 382.293333 237.226667 297.984a63.061333 63.061333 0 0 0-90.496 0.042667A66.133333 66.133333 0 0 0 128 343.978667v345.941333c0.085333 90.154667 71.68 163.285333 160 163.370667h448c88.32-0.085333 159.914667-73.216 160-163.413334V344.021333a65.450667 65.450667 0 0 0-39.466667-60.202666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Download: typeof Icon = createIcon({
  displayName: 'Download',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M832.085333 512H725.333333c-39.253333 0-71.04 25.472-71.082666 56.874667-0.042667 31.445333-31.914667 56.917333-71.210667 56.917333h-142.122667c-39.253333-0.042667-71.082667-25.472-71.125333-56.874667C369.834667 537.472 337.962667 512 298.666667 512H192c-58.88 0.085333-106.581333 38.229333-106.666667 85.333333v113.792c0.128 78.506667 79.658667 142.08 177.792 142.208h497.749334c98.133333-0.128 177.664-63.701333 177.792-142.208V597.333333c-0.085333-47.061333-47.786667-85.248-106.581334-85.333333zM336.64 371.584a34.474667 34.474667 0 0 1 48.597333-48.725333l78.976 79.018666V160.768a34.474667 34.474667 0 0 1 68.864 0v241.066667l78.976-78.976a34.432 34.432 0 0 1 48.597334 48.725333l-113.408 113.408a68.693333 68.693333 0 0 1-48.426667 20.096h-0.554667a68.693333 68.693333 0 0 1-48.426666-20.096L336.64 371.584z'
        fill='currentColor'
      />
    </>
  ),
})

export const Facebook: typeof Icon = createIcon({
  displayName: 'Facebook',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M700.16 556.757333l19.925333-137.941333h-124.501333V329.301333c0-37.76 17.408-74.538667 73.173333-74.538666H725.333333V137.301333S673.962667 128 624.853333 128c-102.528 0-169.557333 66.048-169.557333 185.642667v105.173333H341.333333v137.941333h113.962667v333.44a424.874667 424.874667 0 0 0 140.288 0v-333.44h104.576z'
        fill='currentColor'
      />
    </>
  ),
})

export const Email: typeof Icon = createIcon({
  displayName: 'Email',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M938.666667 321.493333V725.333333a128 128 0 0 1-120.490667 127.786667L810.666667 853.333333H213.333333a128 128 0 0 1-127.786666-120.490666L85.333333 725.333333V321.493333l402.986667 268.672 4.949333 2.816a42.666667 42.666667 0 0 0 37.461334 0l4.949333-2.816L938.666667 321.493333z'
        fill='currentColor'
      />
      <path
        d='M810.666667 170.666667c46.08 0 86.485333 24.32 109.013333 60.885333L512 503.338667l-407.68-271.786667a128 128 0 0 1 100.437333-60.586667L213.333333 170.666667h597.333334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Esport: typeof Icon = createIcon({
  displayName: 'Esport',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M423.594667 679.594667a706.816 706.816 0 0 0 125.952 90.24c-29.866667 51.242667-55.722667 106.666667-77.610667 166.144l2.986667 1.109333a424.576 424.576 0 0 1-225.834667-89.002667l174.506667-168.533333z m202.794666 128c44.245333 18.773333 91.434667 34.048 141.525334 45.866666a424.618667 424.618667 0 0 1-204.288 82.090667c16.426667-41.002667 34.986667-79.616 55.722666-115.968l7.04-12.032zM938.666667 509.226667L938.666667 512a425.045333 425.045333 0 0 1-107.946667 283.690667l2.858667-15.658667a833.536 833.536 0 0 1-159.146667-44.970667 776.362667 776.362667 0 0 1 244.48-215.04l19.712-10.752z m-672-31.274667a772.266667 772.266667 0 0 0 97.109333 140.8L187.434667 788.906667a424.832 424.832 0 0 1-100.394667-238.592 991.829333 991.829333 0 0 0 176.170667-70.528l3.413333-1.834667zM857.173333 261.205333a424.661333 424.661333 0 0 1 71.253334 157.610667c-136.149333 66.176-247.082667 159.402667-332.501334 279.125333a622.378667 622.378667 0 0 1-110.72-77.781333l371.968-358.954667z m-229.290666-159.914666a425.984 425.984 0 0 1 172.373333 96.170666l-375.082667 362.026667a688.64 688.64 0 0 1-85.077333-124.714667c123.562667-80.981333 222.122667-190.933333 295.253333-329.514666l-7.466666-3.968zM177.92 246.613333A1085.44 1085.44 0 0 0 229.546667 401.066667a884.48 884.48 0 0 1-141.141334 59.52 424.021333 424.021333 0 0 1 79.36-200.789334l10.069334-13.141333zM512 85.333333c12.202667 0 24.234667 0.512 36.181333 1.493334-62.72 111.786667-144.170667 201.642667-244.650666 269.824a1040.725333 1040.725333 0 0 1-51.882667-168.106667l-2.688-12.501333A424.832 424.832 0 0 1 512 85.333333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Casion: typeof Icon = createIcon({
  displayName: 'Casion',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M515.413333 498.176l-40.789333-19.968c-13.610667-6.656-27.178667 0-34.005333 13.312-6.784 13.312 0 26.624 13.610666 33.28-13.610667 6.656-20.394667 26.666667-13.610666 33.28 6.826667 13.354667 20.394667 20.010667 34.005333 13.354667l40.789333-19.968 40.746667 19.968c13.610667 6.656 27.221333 0 34.005333-13.312 6.826667-13.312 0-26.666667-13.610666-33.28h-6.784 6.826666c13.568-6.698667 20.352-20.010667 13.568-33.28-6.826667-13.354667-27.178667-20.053333-40.789333-13.354667l-33.962667 19.968z m0 139.861333l-40.789333-20.010666c-13.610667-6.656-27.178667 0-34.005333 13.354666-6.784 13.312 0 26.624 13.610666 33.28-13.610667 6.656-20.394667 19.968-13.610666 33.28 6.826667 13.312 20.394667 19.968 34.005333 13.312l40.789333-19.968 40.746667 19.968c13.610667 6.656 27.221333 0 34.005333-13.312 6.826667-13.312 0-26.624-13.610666-33.28h-6.784 6.826666c13.568-6.656 20.352-19.968 13.568-33.28-6.826667-20.010667-27.178667-20.010667-40.789333-13.354666l-33.962667 20.010666z m0 133.12l-40.789333-19.925333c-13.610667-6.656-27.178667 0-34.005333 13.312-6.784 13.312 0 26.624 13.610666 33.28-13.610667 6.656-20.394667 19.968-13.610666 33.28 6.826667 13.354667 20.394667 20.010667 34.005333 13.354667l40.789333-20.010667 40.746667 20.010667c13.610667 6.656 27.221333 0 34.005333-13.312 6.826667-13.354667 0-26.666667-13.610666-33.28h-6.784 6.826666c13.568-6.698667 20.352-20.010667 13.568-33.322667-6.826667-13.312-27.178667-19.968-40.789333-13.312l-33.962667 19.968v-0.042667z m251.434667-339.584c-20.352 53.290667-33.962667 113.237333-33.962667 166.485334 6.826667 86.570667 33.962667 159.829333 81.536 226.389333 6.826667 13.354667 6.826667 26.666667-6.784 33.28-88.32 59.946667-190.293333 86.613333-299.050666 79.957333-108.714667 6.656-210.688-20.010667-299.008-79.914666-13.653333-6.656-13.653333-19.968-6.826667-33.28 47.573333-66.602667 81.578667-146.517333 88.362667-226.432 0-59.904-13.610667-113.194667-33.962667-173.141334 27.178667 6.656 54.357333 13.354667 74.752 13.354667a302.293333 302.293333 0 0 0 183.466667-59.946667c47.616 39.936 115.584 59.946667 176.725333 59.946667 27.178667 0 47.573333-6.698667 74.752-6.698667z m54.4-312.96C868.821333 138.666667 896 185.216 896 238.506667c0 86.528-95.146667 153.173333-203.904 153.173333-67.968 0-135.936-26.666667-176.682667-79.957333C467.84 358.4 399.872 391.68 331.904 384.981333 223.146667 384.981333 128 318.421333 128 231.808c0-53.248 33.962667-93.184 74.752-119.850667 6.826667 86.613333 74.752 153.173333 163.114667 153.173334h278.656c95.146667 6.656 169.898667-59.946667 176.725333-146.517334z m-54.4-19.968v13.312c0 59.946667-54.357333 113.194667-115.541333 113.194667h-278.613334c-61.184 0-115.541333-53.248-115.541333-113.194667v-13.312C284.330667 91.989333 304.725333 85.333333 331.904 85.333333c67.968 0 135.936 26.624 176.682667 79.914667C556.16 111.957333 624.128 85.333333 692.096 85.333333c27.178667 0 54.4 6.656 74.752 13.312z'
        fill='currentColor'
      />
    </>
  ),
})

export const Fishing: typeof Icon = createIcon({
  displayName: 'Fishing',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M682.666667 200.533333c-72.533333 55.466667-115.2 115.2-128 179.2-12.8 64 8.533333 136.533333 55.466666 213.333334-149.333333-64-260.266667-89.6-328.533333-72.533334-68.266667 12.8-110.933333 51.2-128 115.2 38.4 34.133333 76.8 59.733333 115.2 72.533334 38.4 12.8 76.8 12.8 119.466667 0 42.666667 85.333333 38.4 145.066667-17.066667 174.933333-85.333333 46.933333-307.2-115.2-285.866667-341.333333 64-268.8 260.266667-384 597.333334-341.333334z m51.2 21.333334c98.133333 42.666667 174.933333 162.133333 204.8 345.6-145.066667 38.4-230.4 42.666667-264.533334 21.333333-68.266667-76.8-128-247.466667 59.733334-366.933333z m42.666666 174.933333c-17.066667 0-34.133333 12.8-34.133333 34.133333 0 17.066667 12.8 34.133333 34.133333 34.133334 17.066667 0 34.133333-12.8 34.133334-34.133334s-17.066667-34.133333-34.133334-34.133333zM285.866667 145.066667l8.533333-8.533334c76.8-76.8 170.666667-68.266667 281.6 25.6 4.266667 0-119.466667-17.066667-209.066667 21.333334 4.266667 4.266667-21.333333-12.8-81.066666-38.4z'
        fill='currentColor'
      />
    </>
  ),
})

export const Filter: typeof Icon = createIcon({
  displayName: 'Filter',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M218.88 195.456A42.666667 42.666667 0 0 1 253.525333 128h550.997334a42.666667 42.666667 0 0 1 34.730666 67.456L631.466667 486.4v245.333333a21.333333 21.333333 0 0 1-8.533334 17.066667l-162.133333 121.6a21.333333 21.333333 0 0 1-34.133333-17.066667v-366.933333L218.88 195.456z'
        fill='currentColor'
      />
    </>
  ),
})

export const Clean: typeof Icon = createIcon({
  displayName: 'Clean',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M379.989333 327.552l391.125334 384a592.554667 592.554667 0 0 1-183.936 200.533333 36.437333 36.437333 0 0 1-20.736 6.528h-33.194667a474.922667 474.922667 0 0 1-240.384-64.64l30.250667-11.221333 55.466666-27.776a413.866667 413.866667 0 0 0 156.074667-136.533333l18.602667-27.306667 1.109333-1.621333a35.968 35.968 0 0 0-60.416-38.826667l-18.645333 27.306667a342.485333 342.485333 0 0 1-128.938667 112.725333l-50.261333 25.130667-73.728 27.306666a458.410667 458.410667 0 0 1-89.173334-105.088l42.112-6.954666a417.962667 417.962667 0 0 0 192.853334-109.013334 35.968 35.968 0 0 0-52.992-48.512 344.576 344.576 0 0 1-154.453334 87.381334l-61.738666 10.112c-0.256-0.682667-0.554667-1.28-0.853334-1.92a178.432 178.432 0 0 1 5.077334-144.298667 180.778667 180.778667 0 0 1 111.786666-94.634667l74.453334-21.845333c31.573333-10.282667 61.952-23.936 90.538666-40.832z m537.514667-189.013333a36.352 36.352 0 0 1 0.426667 51.285333l-170.666667 170.666667 28.757333 28.16a180.522667 180.522667 0 0 1 52.181334 157.013333 508.586667 508.586667 0 0 1-25.173334 95.786667l-360.021333-353.493334 9.898667-6.656a179.797333 179.797333 0 0 1 230.826666 17.066667l11.52 11.221333 171.050667-171.093333a36.394667 36.394667 0 0 1 51.2 0z'
        fill='currentColor'
      />
    </>
  ),
})

export const Exit: typeof Icon = createIcon({
  displayName: 'Exit',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M504.874667 170.453333a108.885333 108.885333 0 0 1 108.885333 108.885334v29.866666a54.442667 54.442667 0 1 1-108.885333 0 29.866667 29.866667 0 0 0-29.866667-29.866666H279.509333a42.666667 42.666667 0 0 0-42.666666 42.666666v350.208a42.666667 42.666667 0 0 0 42.666666 42.666667h201.301334c13.226667 0 24.021333-10.752 24.021333-23.978667 0-27.946667 20.992-50.944 48.085333-54.101333l6.357334-0.341333c30.08 0 54.442667 24.32 54.442666 54.442666v39.210667a93.653333 93.653333 0 0 1-93.653333 93.653333H236.885333A108.885333 108.885333 0 0 1 128 714.88V279.338667a108.885333 108.885333 0 0 1 108.885333-108.885334h267.946667z m-131.882667 314.88a42.666667 42.666667 0 0 1 42.666667-42.666666h311.210666V330.282667a21.333333 21.333333 0 0 1 36.266667-15.189334l169.173333 166.784a21.333333 21.333333 0 0 1 0 30.378667l-169.130666 166.784a21.333333 21.333333 0 0 1-36.309334-15.189333v-112.384H415.658667a42.666667 42.666667 0 0 1-42.666667-42.666667v-23.552z'
        fill='currentColor'
      />
    </>
  ),
})

export const Game: typeof Icon = createIcon({
  displayName: 'Game',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M284.458667 170.666667h113.749333c15.744 0 28.458667-9.557333 28.458667-21.333334S413.952 128 398.208 128H284.458667C268.714667 128 256 137.557333 256 149.333333s12.714667 21.333333 28.458667 21.333334z m341.333333 0h113.792c15.701333 0 28.416-9.557333 28.416-21.333334s-12.714667-21.333333-28.416-21.333333h-113.834667c-15.701333 0-28.416 9.557333-28.416 21.333333s12.714667 21.333333 28.416 21.333334zM768 469.333333a42.666667 42.666667 0 1 1 0-85.333333 42.666667 42.666667 0 0 1 0 85.333333z m-85.333333 85.333334a42.666667 42.666667 0 1 1 0-85.333334 42.666667 42.666667 0 0 1 0 85.333334z m-85.333334-85.333334a42.666667 42.666667 0 1 1 0-85.333333 42.666667 42.666667 0 0 1 0 85.333333z m-213.333333 21.333334h-21.333333v21.333333a42.666667 42.666667 0 1 1-85.333334 0v-21.333333H256a42.666667 42.666667 0 1 1 0-85.333334h21.333333V384a42.666667 42.666667 0 0 1 85.333334 0v21.333333H384a42.666667 42.666667 0 0 1 0 85.333334zM682.666667 298.666667a42.666667 42.666667 0 1 1 0 85.333333 42.666667 42.666667 0 0 1 0-85.333333z m256 372.650666s-32.853333-239.402667-37.930667-268.8c-18.986667-109.525333-75.605333-183.466667-170.666667-188.672V213.333333H293.930667v0.512c-95.061333 5.205333-151.722667 59.264-170.666667 188.629334-4.309333 29.568-37.930667 268.8-37.930667 268.8l0.426667 0.213333c-0.170667 3.242667-0.426667 6.442667-0.426667 9.813333C85.333333 752.725333 140.544 810.666667 208.597333 810.666667c43.648 0 81.92-23.893333 103.850667-59.904l0.426667 0.170666 69.248-120.149333a37.546667 37.546667 0 0 1 32.341333-19.2h195.029333a37.546667 37.546667 0 0 1 32.384 19.2l69.205334 120.149333 0.469333-0.170666c21.888 35.968 60.16 59.904 103.850667 59.904C883.456 810.666667 938.666667 752.768 938.666667 681.258667c0-3.328-0.256-6.528-0.512-9.813334l0.512-0.128z'
        fill='currentColor'
      />
    </>
  ),
})

export const Share: typeof Icon = createIcon({
  displayName: 'Share',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M541.226667 170.752c0-37.12 44.117333-56.533333 71.466666-31.445333l317.312 290.816a42.666667 42.666667 0 0 1 0 62.890666l-317.312 290.816c-27.349333 25.088-71.466667 5.674667-71.466666-31.445333v-149.205333c-226.176 16.512-409.6 188.245333-455.893334 299.178666C132.650667 440.661333 404.565333 339.626667 541.226667 325.461333V170.752z'
        fill='currentColor'
      />
    </>
  ),
})

export const Home: typeof Icon = createIcon({
  displayName: 'Home',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 469.333333c-23.552 0-42.624 19.2-42.666667 43.050667v169.856A42.922667 42.922667 0 0 0 512 725.333333a42.922667 42.922667 0 0 0 42.666667-43.093333V512.426667a42.88 42.88 0 0 0-42.666667-42.837334V469.333333z m343.125333 428.672l-684.586666-1.877333a42.666667 42.666667 0 0 1-42.538667-42.666667v-404.053333a94.72 94.72 0 0 1 36.693333-75.776l287.914667-225.152a95.829333 95.829333 0 0 1 118.442667 0l288.128 225.152c23.253333 17.834667 36.906667 45.952 36.693333 75.776l2.048 405.76a42.666667 42.666667 0 0 1-42.453333 42.837333h-0.341334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Endorse: typeof Icon = createIcon({
  displayName: 'Endorse',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M85.333333 384h128v512H85.333333a42.666667 42.666667 0 0 1-42.666666-42.666667V426.666667a42.666667 42.666667 0 0 1 42.666666-42.666667z m225.834667-55.168l273.066667-273.066667a21.333333 21.333333 0 0 1 27.904-2.005333l36.394666 27.306667a64 64 0 0 1 23.594667 66.986666L622.933333 341.333333H896a85.333333 85.333333 0 0 1 85.333333 85.333334v89.770666a85.333333 85.333333 0 0 1-6.4 32.512l-132.053333 320.64a42.666667 42.666667 0 0 1-39.466667 26.453334H341.333333a42.666667 42.666667 0 0 1-42.666666-42.666667V358.954667a42.666667 42.666667 0 0 1 12.501333-30.165334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Ins: typeof Icon = createIcon({
  displayName: 'Ins',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M252.672 170.666667A82.346667 82.346667 0 0 0 170.666667 253.013333a82.517333 82.517333 0 0 0 81.834666 81.706667c45.141333 0 81.92-36.992 81.877334-82.389333A82.176 82.176 0 0 0 252.672 170.666667z m70.528 236.629333c0-6.869333-1.066667-9.984-9.045333-9.898667-41.6 0.426667-83.157333 0.298667-124.714667 0-6.4 0-7.893333 2.133333-7.893333 8.192 0.170667 146.432 0.170667 292.864 0 439.296 0 6.826667 1.92 8.448 8.533333 8.405334 40.96-0.298667 81.92-0.426667 122.88 0.042666 8.32 0.085333 10.325333-2.346667 10.282667-10.368-0.298667-72.32-0.170667-144.64-0.170667-216.96 0-72.917333-0.085333-145.792 0.128-218.709333z m517.717333 84.992c-13.824-48.981333-42.922667-83.456-92.885333-97.962667-21.888-6.314667-44.288-7.978667-66.986667-8.192-41.216-0.341333-76.544 13.909333-106.410666 42.154667-9.728 9.173333-17.493333 19.968-26.965334 30.677333 0-17.493333-0.256-34.986667 0.128-52.48 0.170667-6.826667-1.706667-9.173333-8.96-9.088-39.168 0.341333-78.378667 0.298667-117.589333 0-6.826667 0-9.173333 1.621333-9.173333 8.874667 0.213333 146.176 0.213333 292.352 0 438.528 0 6.698667 1.877333 8.533333 8.533333 8.448 41.258667-0.256 82.56-0.341333 123.861333 0.042667 7.509333 0.085333 9.344-2.090667 9.301334-9.472-0.256-73.813333-0.128-147.626667-0.170667-221.525334 0-11.904 0.682667-23.722667 2.133333-35.584 6.229333-49.578667 31.488-73.685333 80.128-76.245333 35.541333-1.92 59.904 15.445333 69.717334 49.536 5.333333 18.474667 6.528 37.546667 6.570666 56.533333 0.256 75.946667 0.213333 151.808-0.042666 227.754667 0 6.826667 1.536 9.088 8.746666 9.002667 41.002667-0.341333 82.005333-0.341333 122.965334 0 7.338667 0.085333 9.429333-1.877333 9.429333-9.386667-0.170667-79.786667 0.213333-159.573333 0.042667-239.36-0.085333-37.802667-1.962667-75.52-12.373334-112.213333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Hot: typeof Icon = createIcon({
  displayName: 'Hot',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M170.666667 591.658667C170.666667 786.261333 288.128 938.666667 515.669333 938.666667S853.333333 759.296 853.333333 591.658667c0-167.637333-49.621333-238.165333-104.32-288.682667 11.52 52.352 8.106667 142.122667-43.264 188.970667 19.029333-143.914667-55.808-356.309333-241.877333-406.613334 50.261333 152.746667-72.277333 281.898667-83.285333 350.805334 4.821333-30.250667-51.84-95.829333-27.306667-218.965334C288.426667 258.773333 170.666667 397.013333 170.666667 591.658667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Jackpot: typeof Icon = createIcon({
  displayName: 'Jackpot',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M658.56 404.138667a175.573333 175.573333 0 0 0 30.677333-99.157334A177.066667 177.066667 0 0 0 512 128a177.109333 177.109333 0 0 0-177.237333 176.981333c0 36.778667 11.392 70.869333 30.634666 99.157334a176.213333 176.213333 0 0 0-60.16-10.666667A177.109333 177.109333 0 0 0 128 570.453333a177.066667 177.066667 0 0 0 177.194667 176.981334 177.237333 177.237333 0 0 0 169.429333-124.928c2.176 0.768 4.266667 1.706667 6.528 2.346666 0.426667 6.442667 1.28 12.8 1.28 19.370667 0 116.181333-48.213333 176.981333-162.432 209.152V896h384v-44.202667c-107.690667-33.408-162.474667-93.226667-162.474667-207.573333 0-6.570667 0.853333-12.928 1.28-19.370667 2.261333-0.597333 4.352-1.578667 6.528-2.346666a177.28 177.28 0 0 0 169.386667 124.928A177.066667 177.066667 0 0 0 896 570.453333a177.152 177.152 0 0 0-177.237333-176.981333c-21.162667 0-41.386667 3.84-60.16 10.666667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Interno: typeof Icon = createIcon({
  displayName: 'Interno',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M682.666667 85.333333a42.666667 42.666667 0 0 1 42.666666 42.666667v42.666667h42.666667a85.333333 85.333333 0 0 1 85.333333 85.333333v38.954667h45.098667a42.666667 42.666667 0 0 1 0 85.333333H853.333333v85.333333h45.098667a42.666667 42.666667 0 1 1 0 85.333334H853.333333v85.333333h45.098667a42.666667 42.666667 0 1 1 0 85.333333H853.333333V768a85.333333 85.333333 0 0 1-85.333333 85.333333h-42.666667v42.666667a42.666667 42.666667 0 0 1-85.333333 0v-42.666667h-85.333333v42.666667a42.666667 42.666667 0 0 1-85.333334 0v-42.666667H384v42.666667a42.666667 42.666667 0 0 1-85.333333 0v-42.666667H256a85.333333 85.333333 0 0 1-85.333333-85.333333v-46.378667H128a42.666667 42.666667 0 0 1 0-85.333333h42.666667v-85.333333H128a42.666667 42.666667 0 0 1 0-85.333334h42.666667v-85.333333H128a42.666667 42.666667 0 1 1 0-85.333333h42.666667V256a85.333333 85.333333 0 0 1 85.333333-85.333333h42.666667V128a42.666667 42.666667 0 1 1 85.333333 0v42.666667h85.333333V128a42.666667 42.666667 0 1 1 85.333334 0v42.666667h85.333333V128a42.666667 42.666667 0 0 1 42.666667-42.666667z m85.333333 170.666667H256v512h512V256z m-128 85.333333a42.666667 42.666667 0 0 1 42.666667 42.666667v256a42.666667 42.666667 0 0 1-42.666667 42.666667H384a42.666667 42.666667 0 0 1-42.666667-42.666667V384a42.666667 42.666667 0 0 1 42.666667-42.666667h256z'
        fill='currentColor'
      />
    </>
  ),
})

export const Instagram: typeof Icon = createIcon({
  displayName: 'Instagram',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M704.170667 276.650667a43.178667 43.178667 0 1 0 0 86.4 43.178667 43.178667 0 0 0 0-86.4zM512 608a96 96 0 1 1 0-192 96 96 0 0 1 0 192z m0-280.874667a184.874667 184.874667 0 1 0 0 369.749334 184.874667 184.874667 0 0 0 0-369.749334z m293.034667 330.368c-1.578667 35.072-7.466667 54.144-12.373334 66.816a111.829333 111.829333 0 0 1-26.922666 41.386667 111.701333 111.701333 0 0 1-41.386667 26.965333c-12.714667 4.906667-31.786667 10.794667-66.858667 12.373334-37.973333 1.749333-49.365333 2.133333-145.493333 2.133333s-107.52-0.384-145.493333-2.133333c-35.072-1.578667-54.144-7.466667-66.816-12.373334a111.36 111.36 0 0 1-41.386667-26.922666 111.530667 111.530667 0 0 1-26.922667-41.386667c-4.949333-12.714667-10.837333-31.786667-12.373333-66.858667-1.792-37.973333-2.133333-49.365333-2.133333-145.493333s0.341333-107.52 2.133333-145.493333c1.536-35.072 7.424-54.144 12.373333-66.816 6.528-16.810667 14.293333-28.8 26.88-41.386667 12.629333-12.629333 24.618667-20.394667 41.386667-26.965333 12.714667-4.906667 31.786667-10.752 66.858667-12.373334 37.973333-1.706667 49.365333-2.090667 145.493333-2.090666s107.52 0.384 145.493333 2.090666c35.072 1.621333 54.144 7.466667 66.858667 12.373334 16.768 6.570667 28.757333 14.336 41.386667 26.965333 12.586667 12.586667 20.394667 24.576 26.88 41.386667 4.949333 12.672 10.837333 31.744 12.416 66.858666 1.706667 37.973333 2.133333 49.322667 2.133333 145.493334 0 96.085333-0.426667 107.477333-2.133333 145.450666z m70.826666-397.013333A188.714667 188.714667 0 0 0 831.573333 192.426667c-21.333333-21.333333-42.794667-34.474667-68.053333-44.288-24.405333-9.472-52.309333-15.957333-93.184-17.834667C629.333333 128.426667 616.277333 128 512 128s-117.333333 0.426667-158.293333 2.304c-40.917333 1.877333-68.821333 8.362667-93.269334 17.834667A188.416 188.416 0 0 0 192.426667 192.426667c-21.333333 21.376-34.474667 42.794667-44.245334 68.053333-9.514667 24.405333-16 52.352-17.877333 93.184C128.426667 394.666667 128 407.722667 128 512s0.426667 117.376 2.304 158.336c1.877333 40.874667 8.362667 68.778667 17.877333 93.226667 9.813333 25.216 22.912 46.677333 44.245334 68.010666 21.333333 21.333333 42.794667 34.474667 68.010666 44.288 24.448 9.472 52.352 15.957333 93.226667 17.834667C394.666667 895.573333 407.722667 896 512 896s117.376-0.426667 158.293333-2.304c40.917333-1.877333 68.821333-8.362667 93.226667-17.834667a188.416 188.416 0 0 0 68.053333-44.288c21.333333-21.333333 34.474667-42.794667 44.288-68.010666 9.472-24.448 15.957333-52.352 17.834667-93.226667 1.877333-40.96 2.304-54.058667 2.304-158.336s-0.426667-117.376-2.304-158.293333c-1.877333-40.874667-8.362667-68.821333-17.834667-93.226667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Meun: typeof Icon = createIcon({
  displayName: 'Meun',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M128 256a42.666667 42.666667 0 0 1 42.666667-42.666667h682.666666a42.666667 42.666667 0 0 1 42.666667 42.666667v21.333333a42.666667 42.666667 0 0 1-42.666667 42.666667H170.666667a42.666667 42.666667 0 0 1-42.666667-42.666667V256z m0 245.333333a42.666667 42.666667 0 0 1 42.666667-42.666666h682.666666a42.666667 42.666667 0 0 1 42.666667 42.666666v21.333334a42.666667 42.666667 0 0 1-42.666667 42.666666H170.666667a42.666667 42.666667 0 0 1-42.666667-42.666666v-21.333334z m42.666667 202.666667a42.666667 42.666667 0 0 0-42.666667 42.666667v21.333333a42.666667 42.666667 0 0 0 42.666667 42.666667h682.666666a42.666667 42.666667 0 0 0 42.666667-42.666667v-21.333333a42.666667 42.666667 0 0 0-42.666667-42.666667H170.666667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Providers: typeof Icon = createIcon({
  displayName: 'Providers',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M659.029333 42.666667c54.058667 0 33.792 31.061333 30.037334 36.266666l-0.554667 0.682667-126.421333 166.4S725.333333 807.936 725.333333 835.669333c0 27.733333-209.792 145.664-234.666666 145.664-24.874667 0-234.666667-114.602667-234.666667-145.621333 0-30.976 163.242667-589.653333 163.242667-589.653333L285.44 79.573333S265.813333 42.666667 324.821333 42.666667h334.208zM597.333333 256l165.333334 274.730667a45.056 45.056 0 0 1-1.450667 44.970666L716.544 640 597.333333 256z'
        fill='currentColor'
      />
    </>
  ),
})

export const Point: typeof Icon = createIcon({
  displayName: 'Point',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 512m-170.666667 0a170.666667 170.666667 0 1 0 341.333334 0 170.666667 170.666667 0 1 0-341.333334 0Z'
        fill='currentColor'
      />
    </>
  ),
})

export const Ranking: typeof Icon = createIcon({
  displayName: 'Ranking',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M405.333333 192a42.666667 42.666667 0 0 1 42.666667-42.666667h128a42.666667 42.666667 0 0 1 42.666667 42.666667v640a42.666667 42.666667 0 0 1-42.666667 42.666667h-128a42.666667 42.666667 0 0 1-42.666667-42.666667v-640z m-298.666666 213.333333a42.666667 42.666667 0 0 1 42.666666-42.666666h128a42.666667 42.666667 0 0 1 42.666667 42.666666v426.666667a42.666667 42.666667 0 0 1-42.666667 42.666667h-128a42.666667 42.666667 0 0 1-42.666666-42.666667v-426.666667z m640 128a42.666667 42.666667 0 0 0-42.666667 42.666667v256a42.666667 42.666667 0 0 0 42.666667 42.666667h128a42.666667 42.666667 0 0 0 42.666666-42.666667v-256a42.666667 42.666667 0 0 0-42.666666-42.666667h-128z'
        fill='currentColor'
      />
    </>
  ),
})

export const LiveCasino: typeof Icon = createIcon({
  displayName: 'LiveCasino',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 213.333333s266.837333 0 333.397333 17.834667c36.693333 9.813333 65.621333 38.698667 75.434667 75.434667C938.666667 373.12 938.666667 512 938.666667 512s0 138.837333-17.834667 205.397333a106.837333 106.837333 0 0 1-75.434667 75.392C778.837333 810.666667 512 810.666667 512 810.666667s-266.837333 0-333.397333-17.877334a106.837333 106.837333 0 0 1-75.434667-75.392C85.333333 650.837333 85.333333 512 85.333333 512s0-138.88 17.834667-205.397333c9.813333-36.693333 38.698667-65.621333 75.434667-75.434667C245.162667 213.333333 512 213.333333 512 213.333333z m-75.178667 422.613334l183.893334-93.141334a34.261333 34.261333 0 0 0 0-61.610666l-183.893334-93.141334C412.8 375.850667 384 392.661333 384 418.858667v186.282666c0 26.197333 28.8 43.008 52.821333 30.805334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Luck: typeof Icon = createIcon({
  displayName: 'Luck',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M714.368 404.650667a21.333333 21.333333 0 0 1 18.688 6.826666l58.154667 64a21.333333 21.333333 0 0 0 36.778666-10.581333l15.402667-85.077333a21.333333 21.333333 0 0 1 12.245333-15.658667l78.805334-35.541333a21.333333 21.333333 0 0 0 1.322666-38.229334l-76.16-40.96a21.333333 21.333333 0 0 1-11.093333-16.426666l-9.429333-85.973334a21.333333 21.333333 0 0 0-35.968-13.098666L740.693333 193.706667a21.333333 21.333333 0 0 1-19.072 5.504l-84.693333-17.578667a21.333333 21.333333 0 0 0-23.552 30.122667l37.546667 77.909333a21.333333 21.333333 0 0 1-0.682667 19.84l-42.88 75.093333a21.333333 21.333333 0 0 0 21.376 31.701334l85.674667-11.648zM379.008 866.133333a42.666667 42.666667 0 0 1 39.68 0l127.658667 67.114667a42.666667 42.666667 0 0 0 61.866666-45.013333l-24.32-142.08a42.666667 42.666667 0 0 1 12.245334-37.802667l103.253333-100.693333a42.666667 42.666667 0 0 0-23.637333-72.746667l-142.72-20.736a42.666667 42.666667 0 0 1-32.085334-23.338667l-63.829333-129.322666a42.666667 42.666667 0 0 0-76.544 0l-63.829333 129.28a42.666667 42.666667 0 0 1-32.128 23.381333l-142.72 20.736a42.666667 42.666667 0 0 0-23.637334 72.789333l103.253334 100.650667a42.666667 42.666667 0 0 1 12.288 37.76L189.44 888.32a42.666667 42.666667 0 0 0 61.866667 44.970667L379.008 866.133333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Rise: typeof Icon = createIcon({
  displayName: 'Rise',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M685.909333 280.661333a42.666667 42.666667 0 0 1 42.666667-42.666666h139.904a42.666667 42.666667 0 0 1 42.666667 42.666666V896a42.666667 42.666667 0 0 1-42.666667 42.666667h-139.904a42.666667 42.666667 0 0 1-42.666667-42.666667V280.661333zM385.621333 480.853333a42.666667 42.666667 0 0 1 42.666667-42.666666h139.904a42.666667 42.666667 0 0 1 42.666667 42.666666V896a42.666667 42.666667 0 0 1-42.666667 42.666667h-139.904a42.666667 42.666667 0 0 1-42.666667-42.666667v-415.146667zM128 588.373333a42.666667 42.666667 0 0 0-42.666667 42.666667V896a42.666667 42.666667 0 0 0 42.666667 42.666667h139.904a42.666667 42.666667 0 0 0 42.666667-42.666667v-264.96a42.666667 42.666667 0 0 0-42.666667-42.666667H128z'
        fill='currentColor'
      />
      <path
        d='M433.194667 183.637333a50.048 50.048 0 0 1 67.456 73.984l-280.746667 256a50.048 50.048 0 0 1-67.413333-73.941333l280.746666-256z'
        fill='currentColor'
      />
      <path
        d='M331.392 121.770667A21.333333 21.333333 0 0 1 346.496 85.333333h227.413333a21.333333 21.333333 0 0 1 21.333334 21.333334v227.456a21.333333 21.333333 0 0 1-36.394667 15.104l-227.413333-227.456z'
        fill='currentColor'
      />
    </>
  ),
})

export const Gift: typeof Icon = createIcon({
  displayName: 'Gift',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M745.045333 270.549333a84.266667 84.266667 0 0 1-59.861333 24.874667h-179.242667l117.632-138.581333c7.850667-8.448 17.408-15.274667 27.989334-19.968a84.48 84.48 0 0 1 111.274666 41.173333c14.506667 31.573333 7.637333 68.693333-17.365333 93.141333l-0.426667-0.64z m-237.738666 24.874667H326.997333c-46.378667 1.152-84.906667-34.986667-86.058666-80.768-1.194667-45.781333 35.456-83.797333 81.834666-84.949333 13.397333-0.341333 26.666667 2.474667 38.698667 8.234666 10.538667 4.693333 20.053333 11.52 27.776 19.968l118.058667 137.514667z m34.901333 50.773333h303.616c14.421333 0.085333 26.112 10.837333 26.197333 24.106667v72.448c0 13.354667-11.733333 24.149333-26.197333 24.149333h-304.597333l0.981333-120.746666z m-62.976 0v120.746667H174.208a27.562667 27.562667 0 0 1-18.602667-7.082667 23.253333 23.253333 0 0 1-7.68-17.066666V370.432c0.085333-13.312 11.818667-24.021333 26.282667-24.149333l305.066667-0.128zM478.378667 853.333333H237.952c-36.352 0-65.834667-29.44-65.834667-65.834666V515.84h306.986667v337.408l-0.64 0.128z m369.962666-337.578666v271.616c0 36.352-29.44 65.834667-65.792 65.834666h-241.322666v-337.450666h307.114666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Slots: typeof Icon = createIcon({
  displayName: 'Slots',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M833.365333 824.106667l-51.029333-43.946667a74.282667 74.282667 0 0 0-48.298667-17.194667h-118.016L605.866667 701.44c-1.621333-9.642667-11.221333-16.810667-22.528-16.810667h-14.378667V512c-18.304 3.84-37.290667 6.144-56.917333 6.144-19.626667 0-38.613333-2.304-56.917334-6.144v172.629333h-14.336c-11.349333 0-20.949333 7.168-22.528 16.810667l-10.24 61.525333H289.962667c-18.090667 0-35.413333 6.186667-48.213334 17.237334l-51.114666 43.904c-12.8 11.008-19.968 25.941333-19.968 41.557333v33.834667c0 21.632 20.394667 39.168 45.525333 39.168h591.616c25.173333 0 45.525333-17.493333 45.525333-39.168v-33.834667c0-15.616-7.168-30.549333-19.968-41.557333zM469.333333 213.333333a42.666667 42.666667 0 1 1 0 85.333334 42.666667 42.666667 0 0 1 0-85.333334z m42.666667 256a192 192 0 1 0 0-384 192 192 0 0 0 0 384z'
        fill='currentColor'
      />
    </>
  ),
})

export const Rocket: typeof Icon = createIcon({
  displayName: 'Rocket',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M663.893333 450.56a64 64 0 1 1-90.496-90.453333 64 64 0 0 1 90.538667 90.453333z m195.114667-322.133333l-96 15.530666c-95.744 13.226667-179.754667 56.490667-240.938667 124.074667L414.506667 385.962667l-146.602667-8.618667a22.314667 22.314667 0 0 0-19.712 9.813333l-73.770667 110.122667a22.186667 22.186667 0 0 0 9.258667 32.512l104.021333 47.36 159.146667 159.061333 47.36 104.106667c5.632 12.458667 21.077333 16.853333 32.426667 9.301333l111.786666-74.154666a22.186667 22.186667 0 0 0 9.856-19.968l-9.770666-146.474667 117.418666-107.136c67.584-61.141333 110.933333-145.237333 124.117334-240.896l15.530666-96a31.872 31.872 0 0 0-36.565333-36.565333zM264.362667 642.474667a8.362667 8.362667 0 0 0-11.733334-0.128c-6.357333 6.101333-15.104 14.762667-18.218666 17.92C130.901333 763.733333 128 896 128 896s132.266667-2.901333 235.733333-106.410667c3.157333-3.114667 11.776-11.904 17.92-18.218666a8.32 8.32 0 0 0-0.128-11.733334l-117.162666-117.162666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Telegram: typeof Icon = createIcon({
  displayName: 'Telegram',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M938.112 233.728c-11.776 127.573333-62.933333 436.48-88.917333 579.328-11.008 60.416-32.725333 80.554667-53.674667 82.602667-45.824 4.266667-80.213333-30.976-124.373333-60.458667-69.12-46.464-108.16-75.392-175.274667-120.874667-77.525333-52.437333-27.306667-81.237333 16.896-128.341333 11.605333-12.373333 212.48-199.893333 216.448-216.874667a16.682667 16.682667 0 0 0-3.669333-14.250666 17.621333 17.621333 0 0 0-16.213334-1.578667c-7.04 1.536-117.504 76.330667-331.605333 224.426667a147.328 147.328 0 0 1-85.077333 32.341333A547.242667 547.242667 0 0 1 170.666667 580.352c-49.194667-16.384-88.32-25.088-85.12-52.906667 1.792-14.506667 21.205333-29.354667 58.410666-44.501333 228.906667-102.357333 381.610667-169.813333 458.112-202.496 218.154667-93.056 263.466667-109.226667 293.034667-109.781333 37.162667-0.512 46.08 30.848 43.093333 63.061333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Lobby: typeof Icon = createIcon({
  displayName: 'Lobby',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M665.6 754.346667v21.674666c0 5.973333 4.906667 10.837333 10.965333 10.837334h109.738667a10.88 10.88 0 0 0 10.965333-10.837334v-21.674666a10.88 10.88 0 0 0-10.965333-10.88v-260.266667a10.88 10.88 0 0 0 10.965333-10.794667v-21.674666a10.837333 10.837333 0 0 0-10.965333-10.837334h-109.738667a10.88 10.88 0 0 0-10.965333 10.837334v21.674666a10.666667 10.666667 0 0 0 8.661333 10.368v261.12a10.709333 10.709333 0 0 0-8.661333 10.453334zM512 326.058667a62.72 62.72 0 0 1-63.061333-62.421334A62.72 62.72 0 0 1 512 201.344a62.72 62.72 0 0 1 63.104 62.293333A62.72 62.72 0 0 1 512 326.101333z m372.906667-33.408l-362.026667-204.458667a22.186667 22.186667 0 0 0-21.76 0L139.050667 292.650667a21.888 21.888 0 0 0-11.050667 18.773333v63.402667c0 5.973333 4.906667 10.837333 10.965333 10.837333h746.069334A10.88 10.88 0 0 0 896 374.826667V311.466667a21.717333 21.717333 0 0 0-11.093333-18.773334M226.773333 754.346667v21.674666c0 5.973333 4.906667 10.837333 10.965334 10.837334h109.738666a10.88 10.88 0 0 0 10.965334-10.837334v-21.674666a10.922667 10.922667 0 0 0-10.965334-10.88v-260.266667a10.88 10.88 0 0 0 10.965334-10.794667v-21.674666a10.837333 10.837333 0 0 0-10.965334-10.837334H237.696a10.88 10.88 0 0 0-10.965333 10.837334v21.674666c0 5.973333 4.906667 10.837333 10.965333 10.837334v260.266666a10.922667 10.922667 0 0 0-10.965333 10.837334m647.296 86.741333H149.973333A21.845333 21.845333 0 0 0 128 862.72v65.066667c0 5.973333 4.906667 10.837333 10.965333 10.837333h746.069334a10.88 10.88 0 0 0 10.965333-10.837333V862.72c0-11.946667-9.813333-21.674667-21.973333-21.674667M446.165333 754.346667v21.674666c0 5.973333 4.906667 10.837333 10.965334 10.837334h109.738666a10.88 10.88 0 0 0 10.965334-10.837334v-21.674666a10.752 10.752 0 0 0-9.813334-10.666667v-260.693333a10.794667 10.794667 0 0 0 9.813334-10.666667v-21.589333a10.837333 10.837333 0 0 0-10.965334-10.837334h-109.738666a10.88 10.88 0 0 0-10.965334 10.837334v21.674666c0 5.546667 4.352 10.026667 9.813334 10.581334v260.693333a10.752 10.752 0 0 0-9.813334 10.666667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Success: typeof Icon = createIcon({
  displayName: 'Success',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m-42.538667-256l301.653334-301.696-60.330667-60.330667-241.322667 241.365333-120.704-120.704-60.330666 60.330667L469.461333 682.666667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Tiktok: typeof Icon = createIcon({
  displayName: 'Tiktok',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M851.754667 315.008c0-3.456-0.085333-3.584-3.754667-3.541333a167.893333 167.893333 0 0 1-26.410667-2.261334c-31.744-4.693333-134.613333-57.770667-152.021333-144.64-0.341333-1.621333-4.266667-23.168-4.181333-32.384 0-4.096-0.085333-4.096-4.181334-4.138666h-123.690666c-8.106667 0-6.954667-0.981333-6.954667 6.997333v515.029333c0 6.4-0.170667 12.8-1.28 19.072-6.101333 33.237333-23.381333 59.264-52.693333 77.013334-25.386667 15.36-52.906667 19.754667-82.176 14.08-9.216-1.792-17.877333-5.205333-26.538667-8.618667a139.776 139.776 0 0 1-2.133333-1.877333c-2.858667-2.389333-6.058667-4.352-9.216-6.485334-37.248-25.386667-54.954667-60.586667-49.536-104.704 5.418667-44.672 31.573333-75.008 74.666666-90.624 12.885333-4.693333 26.453333-6.613333 40.149334-5.888 8.874667 0.469333 17.664 1.578667 26.24 3.968 2.986667 0.853333 4.565333-0.213333 4.736-3.285333l0.085333-3.285333c0-30.805333-1.194667-98.133333-1.322667-98.261334 0.042667-8.874667 0.042667-17.749333 0.213334-26.624 0.042667-2.56-1.28-2.986667-3.413334-3.285333a260.608 260.608 0 0 0-48.853333-1.066667 250.752 250.752 0 0 0-65.706667 13.653334 245.888 245.888 0 0 0-141.525333 128.853333 236.117333 236.117333 0 0 0-20.565333 121.130667c1.664 17.408 4.992 34.432 10.368 51.072 15.530667 47.872 43.648 87.125333 83.626666 118.229333 4.053333 3.2 7.978667 6.656 12.8 8.704l6.144 5.333333c6.485333 4.778667 13.397333 8.917333 20.650667 12.373334 44.714667 21.76 91.861333 30.592 141.568 24.618666 64.469333-7.722667 118.186667-35.84 160.426667-84.181333 39.850667-45.568 59.178667-99.029333 59.52-158.805333 0.512-85.504 0.128-171.008 0.170666-256.512 0-2.048-1.194667-4.906667 1.109334-5.973334 1.792-0.810667 3.584 1.536 5.248 2.645334a323.84 323.84 0 0 0 105.088 44.501333 302.677333 302.677333 0 0 0 66.858666 7.936c7.125333 0 8.064-0.384 8.064-7.338667 0.042667-30.378667-1.578667-113.365333-1.578666-121.429333z'
        fill='currentColor'
      />
    </>
  ),
})

export const User: typeof Icon = createIcon({
  displayName: 'User',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M458.581333 653.610667v87.978666c0 26.368 20.906667 47.786667 46.677334 47.786667 25.770667 0 46.634667-21.418667 46.634666-47.786667v-88.021333c0-26.368-20.864-47.744-46.634666-47.744-25.728 0-46.677333 21.376-46.677334 47.786667z m-97.408-26.794667a10.794667 10.794667 0 0 0-10.282666-7.68H297.813333c-93.781333 0-169.813333 77.824-169.813333 173.866667v77.141333a25.6 25.6 0 0 0 25.258667 25.856h278.698666a11.093333 11.093333 0 0 0 10.325334-14.506667l-81.066667-254.72z m351.530667-7.68h-52.906667a10.794667 10.794667 0 0 0-10.282666 7.68l-81.109334 254.677333a11.050667 11.050667 0 0 0 10.282667 14.506667h278.570667a25.6 25.6 0 0 0 25.258666-25.856v-77.141333c0-96-76.074667-173.824-169.813333-173.824z m-207.445333-64.682667c115.029333 0 208.256-95.445333 208.256-213.205333S620.288 128 505.258667 128 296.96 223.445333 296.96 341.248c0 117.76 93.269333 213.205333 208.298667 213.205333z'
        fill='currentColor'
      />
    </>
  ),
})

export const Support: typeof Icon = createIcon({
  displayName: 'Support',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M770.133333 426.666667H253.952C231.552 426.666667 213.333333 407.594667 213.333333 384c0-23.594667 18.218667-42.666667 40.576-42.666667H770.133333c22.357333 0 40.533333 19.072 40.533334 42.666667 0 23.594667-18.133333 42.666667-40.533334 42.666667zM341.333333 512h298.666667a42.666667 42.666667 0 1 1 0 85.333333H341.333333a42.666667 42.666667 0 1 1 0-85.333333z m429.269334-341.333333H253.525333C160.768 171.008 85.632 254.805333 85.333333 358.357333v262.954667c0.085333 103.68 75.306667 187.733333 168.192 187.989333H378.026667l84.821333 104.96c24.533333 30.336 66.517333 32.725333 93.738667 5.333334v-0.042667l4.778666-5.333333 84.949334-104.917334h124.330666C863.488 809.045333 938.666667 724.906667 938.666667 621.312V358.357333c-0.213333-103.509333-75.306667-187.306667-168.064-187.690666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Medal: typeof Icon = createIcon({
  displayName: 'Medal',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M572.501333 85.333333c4.010667 0 7.978667 0.426667 11.946667 1.322667 11.946667 2.773333 22.357333 9.941333 32.341333 18.133333l14.848 12.544c7.424 6.229333 14.933333 12.032 23.04 16 24.576 12.074667 58.325333 9.770667 79.402667 27.008 21.248 17.408 26.453333 51.498667 43.434667 73.258667 16.896 21.546667 48.298667 34.304 60.245333 59.477333 11.733333 24.832 2.005333 57.856 8.106667 85.248 5.888 26.581333 28.8 51.925333 28.8 80.341334 0 28.416-22.912 53.76-28.842667 80.213333-6.144 27.52 3.584 60.544-8.106667 85.290667-8.448 18.005333-26.965333 29.653333-43.050666 42.752a169.813333 169.813333 0 0 0-9.173334 7.978666 85.333333 85.333333 0 0 0-7.978666 8.746667 23.552 23.552 0 0 0-4.181334 20.693333l46.677334 174.08a6.613333 6.613333 0 0 1-6.4 8.405334h-0.682667l-93.866667-9.173334c-0.810667-0.170667-1.706667-0.170667-2.56-0.170666a26.88 26.88 0 0 0-15.488 5.034666l-76.8 54.826667a6.656 6.656 0 0 1-10.325333-3.669333L586.666667 832a1.834667 1.834667 0 0 0-2.261334-1.322667c-3.925333 0.853333-7.893333 1.237333-11.904 1.237334-22.826667 0-47.488-12.330667-71.168-12.330667-23.68 0-48.341333 12.330667-71.168 12.330667-4.010667 0-7.978667-0.341333-11.946666-1.28a2.730667 2.730667 0 0 0-3.2 1.962666l-27.093334 101.12a6.741333 6.741333 0 0 1-10.325333 3.712l-76.8-54.826666a26.453333 26.453333 0 0 0-18.048-4.864l-93.866667 9.173333h-0.64a6.698667 6.698667 0 0 1-6.528-5.376 6.656 6.656 0 0 1 0.128-3.029333l47.146667-176a21.205333 21.205333 0 0 0-3.84-18.688 106.069333 106.069333 0 0 0-17.152-16.810667c-16-13.098667-34.56-24.746667-43.093333-42.752-11.733333-24.832-2.005333-57.856-8.106667-85.248C150.954667 512.426667 128 487.082667 128 458.666667c0-28.416 22.912-53.76 28.757333-80.341334 6.144-27.477333-3.584-60.501333 8.106667-85.248 11.904-25.173333 43.306667-37.930667 60.202667-59.477333 16.938667-21.76 22.186667-55.893333 43.434666-73.258667 21.162667-17.237333 54.912-14.933333 79.488-27.093333 24.277333-11.946667 43.434667-40.405333 70.272-46.677333 3.925333-0.853333 7.893333-1.237333 11.904-1.237334 22.826667 0 47.488 12.373333 71.168 12.373334 23.68 0 48.341333-12.373333 71.168-12.373334z m-71.253333 63.317334a309.930667 309.930667 0 0 0-134.101333 589.568 308.522667 308.522667 0 0 0 134.186666 30.464 306.730667 306.730667 0 0 0 159.914667-44.416 308.352 308.352 0 0 0 73.258667-61.354667 307.84 307.84 0 0 0 76.757333-204.245333 309.888 309.888 0 0 0-310.016-310.016z m0.085333 26.666666a283.306667 283.306667 0 0 1 200.32 483.669334A283.306667 283.306667 0 1 1 501.333333 175.36v-0.042667z m14.549334 92.416a12.672 12.672 0 0 0-22.784 0l-53.76 109.098667a6.229333 6.229333 0 0 1-4.778667 3.456l-120.32 17.493333a12.672 12.672 0 0 0-7.04 21.632l87.082667 84.906667c1.493333 1.450667 2.133333 3.541333 1.834666 5.589333l-20.565333 119.893334a12.672 12.672 0 0 0 18.432 13.354666l107.605333-56.533333a6.4 6.4 0 0 1 5.888 0l107.648 56.533333a12.714667 12.714667 0 0 0 18.389334-13.397333l-20.522667-119.850667a6.357333 6.357333 0 0 1 1.792-5.632l87.04-84.906666a12.672 12.672 0 0 0-7.082667-21.632l-120.32-17.450667a6.4 6.4 0 0 1-4.778666-3.456l-53.76-109.098667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Warning: typeof Icon = createIcon({
  displayName: 'Warning',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M512 938.666667C276.352 938.666667 85.333333 747.648 85.333333 512S276.352 85.333333 512 85.333333s426.666667 191.018667 426.666667 426.666667-191.018667 426.666667-426.666667 426.666667z m-42.666667-298.666667v85.333333h85.333334v-85.333333h-85.333334z m0-341.333333v256h85.333334V298.666667h-85.333334z'
        fill='currentColor'
      />
    </>
  ),
})

export const Youtube: typeof Icon = createIcon({
  displayName: 'Youtube',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M919.168 298.581333C938.666667 374.613333 938.666667 512 938.666667 512s0 137.386667-19.498667 213.418667c-10.837333 42.026667-42.538667 75.093333-82.688 86.272C763.562667 832 512 832 512 832s-251.434667 0-324.48-20.309333c-40.32-11.349333-71.978667-44.373333-82.688-86.272C85.333333 649.386667 85.333333 512 85.333333 512s0-137.386667 19.498667-213.418667c10.837333-42.026667 42.538667-75.093333 82.688-86.272C260.565333 192 512 192 512 192s251.562667 0 324.48 20.309333c40.32 11.349333 71.978667 44.373333 82.688 86.272zM426.666667 661.333333l256-149.333333-256-149.333333v298.666666z'
        fill='currentColor'
      />
    </>
  ),
})

export const Usergroup: typeof Icon = createIcon({
  displayName: 'Usergroup',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M400.938667 669.44a27.477333 27.477333 0 0 0-27.648 27.221333v102.485334c0 15.061333 12.373333 27.306667 27.648 27.306666a27.477333 27.477333 0 0 0 27.648-27.306666v-102.485334a27.434667 27.434667 0 0 0-27.648-27.264z m-122.581334 1.28a9.130667 9.130667 0 0 0-8.746666-6.229333H224.469333c-79.786667 0-144.469333 63.744-144.469333 142.421333v63.146667a21.333333 21.333333 0 0 0 21.504 21.205333h237.056c6.314667 0 10.752-5.973333 8.832-11.904l-69.034667-208.64z m299.050667-6.229333h-45.013333a9.130667 9.130667 0 0 0-8.746667 6.229333l-68.992 208.64a9.088 9.088 0 0 0 8.746667 11.904h236.970666a21.333333 21.333333 0 0 0 21.504-21.205333v-63.146667c0-78.677333-64.725333-142.421333-144.469333-142.421333z m236.970667-190.293334h-38.698667c-3.413333 0-6.485333 2.133333-7.552 5.376l-53.888 162.986667c9.685333 8.490667 18.773333 17.365333 27.178667 26.794667h178.773333A18.346667 18.346667 0 0 0 938.666667 651.093333v-54.4c0-67.626667-55.68-122.496-124.288-122.496z m-413.44 137.301334c97.834667 0 177.152-78.208 177.152-174.677334S498.773333 262.144 400.938667 262.144c-97.877333 0-177.194667 78.208-177.194667 174.677333 0 96.426667 79.36 174.677333 177.194667 174.677334z m233.173333-185.728c9.258667 1.706667 18.688 2.816 28.458667 2.816 84.138667 0 152.405333-67.242667 152.405333-150.272 0-83.029333-68.266667-150.314667-152.405333-150.314667a151.68 151.68 0 0 0-144.853334 105.685333 231.893333 231.893333 0 0 1 116.394667 192.085334z m4.608 76.16v89.984c16.896 8.533333 32.768 18.048 47.616 28.586666v-118.613333c0-12.970667-10.666667-23.466667-23.765333-23.466667a23.637333 23.637333 0 0 0-23.850667 23.466667z'
        fill='currentColor'
      />
    </>
  ),
})

export const Date: typeof Icon = createIcon({
  displayName: 'Date',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M311.210667 170.666667a42.666667 42.666667 0 0 1 42.666666-42.666667h15.061334a42.666667 42.666667 0 0 1 42.666666 42.666667v56.533333h200.789334V170.666667a42.666667 42.666667 0 0 1 42.666666-42.666667h15.061334a42.666667 42.666667 0 0 1 42.666666 42.666667v56.533333h75.306667A150.613333 150.613333 0 0 1 938.666667 377.813333v401.578667a150.613333 150.613333 0 0 1-150.613334 150.570667H235.946667A150.613333 150.613333 0 0 1 85.333333 779.349333V377.856a150.613333 150.613333 0 0 1 150.613334-150.613333h75.264V170.666667z m301.184 257.322666H411.605333v8.704a42.666667 42.666667 0 0 1-42.666666 42.666667h-15.061334a42.666667 42.666667 0 0 1-42.666666-42.666667v-8.704H185.728v351.402667c0 27.733333 22.485333 50.176 50.176 50.176h552.192c27.733333 0 50.176-22.485333 50.176-50.176V427.946667h-125.482667v8.704a42.666667 42.666667 0 0 1-42.666666 42.666666h-15.061334a42.666667 42.666667 0 0 1-42.666666-42.666666v-8.704z'
        fill='currentColor'
      />
    </>
  ),
})

export const Label: typeof Icon = createIcon({
  displayName: 'Label',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M256 85.333333a170.666667 170.666667 0 0 0-170.666667 170.666667v632.704a85.333333 85.333333 0 0 0 122.112 76.970667l305.194667-145.749334 303.829333 145.536A85.333333 85.333333 0 0 0 938.666667 888.490667V256a170.666667 170.666667 0 0 0-170.666667-170.666667H256z m246.058667 503.893334l-74.88 39.552a21.333333 21.333333 0 0 1-31.018667-22.485334l14.378667-84.053333a21.333333 21.333333 0 0 0-6.101334-18.773333l-60.885333-59.648a21.333333 21.333333 0 0 1 11.861333-36.352l83.925334-12.245334a21.333333 21.333333 0 0 0 16.042666-11.690666l37.461334-76.245334a21.333333 21.333333 0 0 1 38.314666 0l37.461334 76.245334a21.333333 21.333333 0 0 0 16.042666 11.690666l83.925334 12.245334a21.333333 21.333333 0 0 1 11.861333 36.352L619.52 503.466667a21.333333 21.333333 0 0 0-6.101333 18.858666l14.378666 84.053334a21.333333 21.333333 0 0 1-31.018666 22.442666l-74.88-39.552a21.333333 21.333333 0 0 0-19.882667 0z'
        fill='currentColor'
      />
    </>
  ),
})

export const Calendar: typeof Icon = createIcon({
  displayName: 'Calendar',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M554.666667 469.333333v256h-85.333334v-213.333333h-42.666666v-42.666667h128z'
        fill='currentColor'
      />
      <path
        d='M682.666667 128a42.666667 42.666667 0 0 0-42.666667 42.666667v42.666666H384V170.666667a42.666667 42.666667 0 0 0-85.333333 0v42.666666H256a128 128 0 0 0-128 128v426.666667a128 128 0 0 0 128 128h512a128 128 0 0 0 128-128V341.333333a128 128 0 0 0-128-128h-42.666667V170.666667a42.666667 42.666667 0 0 0-42.666666-42.666667zM213.333333 384h85.333334a42.666667 42.666667 0 0 0 85.333333 0h256a42.666667 42.666667 0 1 0 85.333333 0h85.333334v384a42.666667 42.666667 0 0 1-42.666667 42.666667H256a42.666667 42.666667 0 0 1-42.666667-42.666667V384z'
        fill='currentColor'
      />
    </>
  ),
})

export const Cup: typeof Icon = createIcon({
  displayName: 'Cup',
  viewBox: '0 0 1024 1024',
  path: (
    <>
      <path
        d='M779.776 151.466667h98.56c44.245333 0 60.330667 24.021333 60.330667 60.330666v87.253334a128.938667 128.938667 0 0 1-128.938667 128.938666h-46.592c-18.218667 41.6-49.322667 79.530667-83.413333 107.178667l-16.042667 13.013333c-7.68 6.186667-14.421333 10.325333-20.181333 13.781334-14.464 8.789333-22.485333 13.653333-22.485334 38.528v24.021333h-218.026666v-16.469333c0-30.293333-10.496-37.504-29.184-50.432a297.685333 297.685333 0 0 1-19.328-14.208l-10.197334-8.234667c-34.133333-27.648-65.194667-65.578667-83.413333-107.178667H214.272A128.938667 128.938667 0 0 1 85.333333 299.050667V211.797333c0-37.12 19.541333-60.330667 60.288-60.330666h98.56V85.333333h535.594667v66.133334zM145.28 299.093333c0 38.101333 30.848 68.992 68.992 68.992h31.061333a200.106667 200.106667 0 0 0-0.426666-4.138666c-0.341333-3.157333-0.682667-6.314667-0.682667-9.472V211.413333h-56.32a42.666667 42.666667 0 0 0-42.666667 42.666667V299.093333z m664.448 68.992c38.101333 0 68.992-30.933333 68.992-68.992V254.08a42.666667 42.666667 0 0 0-42.666667-42.666667h-56.277333v143.061334c0 3.157333-0.341333 6.314667-0.682667 9.472a167.594667 167.594667 0 0 0-0.426666 4.138666h31.061333z m-285.013333-131.712c-7.04-14.208-18.389333-14.208-25.386667 0l-20.266667 41.045334-45.354666 6.613333c-15.616 2.261333-19.157333 13.056-7.808 24.106667l32.768 31.957333-7.68 45.141333c-2.688 15.616 6.485333 22.272 20.48 14.933334l40.533333-21.333334 40.533333 21.333334c13.994667 7.338667 23.168 0.682667 20.522667-14.933334L565.333333 340.053333l32.768-32c11.349333-11.008 7.808-21.802667-7.850666-24.064l-45.269334-6.613333-20.309333-41.045333zM703.786667 828.288h122.154666v71.936H198.058667v-71.936h122.154666v-77.184c0-36.821333 29.866667-66.645333 66.688-66.645333h250.197334c36.821333 0 66.688 29.866667 66.688 66.645333v77.184z m-85.248-23.978667v-47.914666H405.504v47.914666h213.12z'
        fill='currentColor'
      />
    </>
  ),
})
